export default {
    "平台店铺商品发布": 1,
    "商品发布": 2,
    "下发仓库": 3,
    "历史记录": 4,
    "类目名称": 5,
    "请选择末级节点！": 6,
    "请选择平台": 7,
    "支持搜索类目": 8,
    "商品图片": 9,
    "商品详情": 10,
    "请上传正确的视频格式！": 11,
    "视频大小不能超过50MB！": 12,
    "有一个素材正在上传中，请等待上传完成！": 13,
    "店铺授权": 14,
    "物流公司档案": 15,
    "新增逻辑仓": 16,
    "新增别名": 17,
    "新增区域": 18,
    "渠道仓档案": 19,
    "国家省市区编辑": 20,
    "别名名称": 21,
    "区域类型": 22,
    "国家": 23,
    "省份": 24,
    "市级": 25,
    "区级": 26,
    "关联国家": 27,
    "关联省": 28,
    "关联市": 29,
    "关联区县": 30,
    "区域编码": 31,
    "区域名称": 32,
    "当前修改未保存，确定返回？": 33,
    "国家省市区": 34,
    "逻辑仓编码": 35,
    "逻辑仓名称": 36,
    "所属实体仓": 37,
    "仓库类型": 38,
    "次品": 39,
    "主仓": 40,
    "负库存控制": 41,
    "店铺新增": 42,
    "店铺昵称": 43,
    "完善信息": 44,
    "下一步": 45,
    "上一步": 46,
    "授权成功": 47,
    "授权失败": 48,
    "所在区\\\\县": 49,
    "请填写店铺昵称！": 50,
    "其他平台": 51,
    "授权指引": 52,
    "渠道仓编码": 53,
    "渠道仓名称": 54,
    "添加": 55,
    "逻辑仓": 56,
    "供货比例": 57,
    "自动分配": 58,
    "供货逻辑仓": 59,
    "操作日志": 60,
    "请选择需要删除的内容！": 61,
    "不可全部删除逻辑仓数据，请至少保留一条！": 62,
    "明细不能为空！": 63,
    "请勿重复添加！": 64,
    "同一实体仓下优先级不能重复！": 65,
    "请先添加明细！": 66,
    "供货比例不能为空！": 67,
    "物流公司编码": 68,
    "物流公司名称": 69,
    "平台": 70,
    "平台物流编号": 71,
    "平台物流名称": 72,
    "前缀": 73,
    "后缀": 74,
    "平台物流对应": 75,
    "物流单号解析配置": 76,
    "删除成功！": 77,
    "内容不能为空！": 78,
    "重复数据，不能添加！": 79,
    "物流公司档案编辑": 80,
    "启用状态": 81,
    "业务信息": 82,
    "请选择需要添加的店铺类型！": 83,
    "是否授权成功？": 84,
    "商品/颜色主图": 85,
    "主图视频": 86,
    "颜色主图": 87,
    "添加图片": 88,
    "建议尺寸：800*800像素，颜色项维护请在“颜色尺寸”栏": 89,
    "视频上传教程": 90,
    "上传图片只能是 JPG,PNG,GIF 格式!": 91,
    "上传图片大小不能超过 2MB!": 92,
    "最多上传{num}张图片": 93,
    "实体仓档案": 94,
    "请输入平台": 95,
    "请输入店铺昵称": 96,
    "渠道仓编辑": 97,
    "启用": 98,
    "停用": 99,
    "授权有效时间": 100,
    "卖家姓名": 101,
    "卖家地址": 102,
    "SKU名称": 103,
    "请完成输入后回车": 104,
    "销售属性": 105,
    "币种": 106,
    "是否组合商品": 107,
    "货号": 108,
    "计算占比成功": 109,
    "计算占比失败": 110,
    "添加成分商品": 111,
    "计算占比": 112,
    "请添加组合商品": 113,
    "删除组合条码": 114,
    "组合条码编码": 115,
    "组合条码名称": 116,
    "占比": 117,
    "确定删除该组合条码?": 118,
    "商品SKU编码": 119,
    "商品SPU编码": 120,
    "当前预售数量": 121,
    "当前预售剩余数量": 122,
    "追加预售数量": 123,
    "本次调整后剩余量不允许小于0": 124,
    "追加预售数量不能为0": 125,
    "追加后预售数量": 126,
    "追加后预售剩余数量": 127,
    "请先选择需要【追加预售数量】的记录！": 128,
    "请选择其中一条记录，进行追加预售数量！": 129,
    "当前所选中明细已作废，不允许追加预售数量！": 130,
    "追加预售数量不能为空或为0！": 131,
    "活动开始时间": 132,
    "活动结束时间": 133,
    "请选择结束时间": 134,
    "平台物流编码": 135,
    "请选择需要推送WMS仓库的商品！": 136,
    "请选择下发仓库！": 137,
    "年季": 138,
    "位": 139,
    "切换类型会清空当前类型明细,是否继续?": 140,
    "规格维度信息": 141,
    "供应商名称": 142,
    "SPU编码": 143,
    "品牌": 144,
    "查找": 145,
    "重置": 146,
    "零售价": 147,
    "国际码": 148,
    "店铺": 149,
    "商品ID": 150,
    "下载": 151,
    "请选择需要下载的店铺": 152,
    "商品ID和时间必填其中一个": 153,
    "平台修改时间": 154,
    "请输入需要下载的店铺！": 155,
    "逻辑仓库": 156,
    "切换组合商品类型会清空数据，确认切换组合商品类型": 157,
    "无法修改": 158,
    "组合商品档案": 159,
    "组合商品档案编辑": 160,
    "商品相关信息": 161,
    "SPU编码由英文字母和数字组成，请合理输入": 162,
    "请选择品牌": 163,
    "价格不能为空": 164,
    "价格是一个数字，请合理输入": 165,
    "请录入条码明细后再保存": 166,
    "福袋类型组合商品一个虚拟条码不允许存在超过十个分组": 167,
    "存在每组抽取行数大于每组福袋商品总行数": 168,
    "福袋类型组合商品不允许存在一个分组超过200行的SKU": 169,
    "普通类型组合商品，一个虚拟条码下不允许超过30条SKU": 170,
    "请选择需要添加的内容！": 171,
    "组合商品编码": 172,
    "组合商品名称": 173,
    "组合类型": 174,
    "福袋": 175,
    "普通组合明细": 176,
    "福袋组合明细": 177,
    "每组抽取数": 178,
    "{str} 不能为空!": 179,
    "请勿重复添加该明细！": 180,
    "请选择需要删除的数据！": 181,
    "新增SKU": 182,
    "快速新增": 183,
    "应用到所有列": 184,
    "请选择需要生成的维度！": 185,
    "备用条码": 186,
    "SKU编辑": 187,
    "SPU编辑": 188,
    "销售状态": 189,
    "采购价": 190,
    "成本价": 191,
    "体积(cm3)": 192,
    "毛重": 193,
    "净重": 194,
    "单位": 195,
    "请选择商品分类！": 196,
    "快速生成": 197,
    "默认供应商": 198,
    "产品介绍": 199,
    "SKU信息": 200,
    "供应商": 201,
    "请选择需要添加的供应商！": 202,
    "该供应商已存在,请勿重复添加！": 203,
    "请选中需要批量应用的数据！": 204,
    "商品数量只能录入正整数": 205,
    "开始日期": 206,
    "商品维度": 207,
    "SKU基本信息": 208,
    "物理属性": 209,
    "固定属性": 210,
    "自定义属性": 211,
    "是否允许拆单": 212,
    "是否自动计算占比？": 213,
    "组合条码": 214,
    "组合商品编码、组合商品名称不能为空！": 215,
    "没有设置成分商品，请点击“添加成分商品”按钮进行设置并保存": 216,
    "数量不能为空，不允许保存": 217,
    "总占比和不等于100%，不允许保存": 218,
    "组合商品详情": 219,
    "多币种维护列表": 220,
    "新增币种成功！": 221,
    "名称已存在！": 222,
    "名称不能为空！": 223,
    "顺序号已存在！": 224,
    "没有返回新的数据ID！": 225,
    "当前记录": 226,
    "不允许追加预售数量！": 227,
    "不允许修改结束时间！": 228,
    "分类编码": 229,
    "分类名称": 230,
    "分类英文名称": 231,
    "父类": 232,
    "启用多维度规格": 233,
    "规格维度": 234,
    "一维": 235,
    "二维": 236,
    "三维": 237,
    "规格名称一": 238,
    "规格名称二": 239,
    "规格名称三": 240,
    "自定义属性名称": 241,
    "自定义属性别名": 242,
    "属性类型": 243,
    "格式不正确!": 244,
    "属性编码": 245,
    "属性名称": 246,
    "属性别名": 247,
    "属性值": 248,
    "属性形式": 249,
    "属性归属": 250,
    "请选择要删除的属性值！": 251,
    "商品SPU编辑": 252,
    "维度码": 253,
    "维度值": 254,
    "正常销售": 255,
    "暂停销售": 256,
    "提交": 257,
    "复制单据": 258,
    "商品SKU编辑": 259,
    "商品品类": 260,
    "是": 261,
    "否": 262,
    "序号": 263,
    "语言": 264,
    "全屏": 265,
    "修改密码": 266,
    "消息提示音": 267,
    "登录": 268,
    "第三方登录": 269,
    "请输入验证码": 270,
    "请输入用户名": 271,
    "请输入新密码": 272,
    "密码长度6-18位": 273,
    "密码中必须包含数字及大小写字母!": 274,
    "皮肤": 275,
    "消息": 276,
    "主题色": 277,
    "换肤": 278,
    "完成": 279,
    "确定": 280,
    "请输入": 281,
    "取消": 282,
    "平台售后单号": 283,
    "付款时间": 284,
    "请选择": 285,
    "错误": 286,
    "请输入密码": 287,
    "请按住滑块，拖动到最右侧": 288,
    "请输入手机号": 289,
    "请输入正确的手机号": 290,
    "请输入短信验证码": 291,
    "安全提示": 292,
    "当前账号登录中，是否继续登录?": 293,
    "当前密码1个月未修改，为保数据安全请立即修改!": 294,
    "重新获取": 295,
    "获取验证码成功": 296,
    "忘记密码": 297,
    "拖动滑块验证": 298,
    "验证成功": 299,
    "手机登录": 300,
    "获取验证码": 301,
    "换吊牌": 302,
    "修改退回物流公司": 303,
    "SN码": 304,
    "来源平台=旺店通，禁止修改！": 305,
    "退货入库结果单": 306,
    "无名件入库结果单": 307,
    "卡单": 308,
    "没有返回新单子的ID！": 309,
    "出库通知单": 310,
    "入库通知单": 311,
    "请选择业务单据类型": 312,
    "编码": 313,
    "名称": 314,
    "实体仓": 315,
    "下载商品": 316,
    "下载PO单": 317,
    "修改礼品卡信息": 318,
    "新增售后申请单": 319,
    "选择订单": 320,
    "补差价": 321,
    "对等换货": 322,
    "手动指定效期": 323,
    "修改预计发货时间": 324,
    "修改周期购预计发货时间": 325,
    "寻仓寻物流": 326,
    "复制权限": 327,
    "虚拟发货": 328,
    "批量设置": 329,
    "请选择需要新增售后申请单记录！": 330,
    "仅允许对仓库发货或平台发货的订单进行新增": 331,
    "JITX的订单不允许拆分！": 332,
    "非缺货、待审核订单不允许修改预计发货时间！": 333,
    "退货入库结果单-错发强制匹配": 334,
    "无名件入库结果单-错发强制匹配": 335,
    "退货入库结果单-手工匹配": 336,
    "无名件入库结果单-手工匹配": 337,
    "策略ID": 338,
    "属性ID": 339,
    "类目ID": 340,
    "请填写筛选条件或勾选要操作的数据！": 341,
    "是否确定该操作？": 342,
    "请先勾选要操作的数据！": 343,
    "是否确定转化？": 344,
    "请勾选要操作的数据！": 345,
    "是否确定对该订单进行【反审核并修改】操作？": 346,
    "是否确定删除要操作的账单？": 347,
    "请设置水印显示文字": 348,
    "预售计划单": 349,
    "修改的数据未保存,确定返回?": 350,
    "客户订单": 351,
    "请先勾选要作废的卡号信息数据！": 352,
    "请添加商品明细！": 353,
    "明细赔付金额不能为0，请重新录入！": 354,
    "是否确认执行": 355,
    "至少开启一项寻源策略！": 356,
    "组合商品编辑": 357,
    "结算策略": 358,
    "指定商品比例同步策略编辑": 359,
    "比例同步策略编辑": 360,
    "客户寻源策略编辑": 361,
    "渠道库存管理": 362,
    "逻辑解冻单": 363,
    "预盈亏": 364,
    "多渠道调拨单": 365,
    "监控平台": 366,
    "概览": 367,
    "巡检": 368,
    "全渠道自提单": 369,
    "全渠道退货扫描": 370,
    "全渠道发货单": 371,
    "全渠道退货单详情": 372,
    "全渠道订单详情": 373,
    "订单新增": 374,
    "订单详情": 375,
    "pos背景图片设置": 376,
    "线上促销活动": 377,
    "TOB寻源策略定义编辑": 378,
    "寻源策略编辑": 379,
    "请输入店铺": 380,
    "请选择付款时间!": 381,
    "拒绝换货原因": 382,
    "请选择需要拒绝的换货单！": 383,
    "换货状态不满足，不能拒绝换货！": 384,
    "拒绝换货原因请求失败": 385,
    "拒绝换货原因不能为空": 386,
    "请先选择需要拒绝换货的单据！": 387,
    "拒绝换货失败": 388,
    "商品素材": 389,
    "账单日期": 390,
    "账单日期和平台单号必须任选其一！": 391,
    "账单日期和平台单号只能任选其一！": 392,
    "百秋平台不允许下载": 393,
    "请选择需要下载的平台店铺！": 394,
    "平台宝贝ID": 395,
    "已经上传": 396,
    "条": 397,
    "排除会员导入": 398,
    "旧密码": 399,
    "请输入旧密码": 400,
    "新密码": 401,
    "密码安全程度": 402,
    "确认密码": 403,
    "两次输入的密码不一致": 404,
    "密码为8-20位，至少包含大小写字母/数字/符号 3种组合": 405,
    "低": 406,
    "新旧密码必须不一致": 407,
    "请先选择批量修改的列,然后下载模板": 408,
    "下载覆盖模板": 409,
    "请选取需要导入的文件": 410,
    "请选中要修改的字段！": 411,
    "账号登录": 412,
    "请输入账号": 413,
    "sso登录": 414,
    "找回密码": 415,
    "请输入邮箱地址": 416,
    "请输入确认密码": 417,
    "验证码": 418,
    "请填写验证码": 419,
    "取 消": 420,
    "确 定": 421,
    "请输入邮箱": 422,
    "请输入正确的邮箱": 423,
    "点击获取验证码": 424,
    "两次密码输入不一致!": 425,
    "用户名不能为空!": 426,
    "s后重新获取": 427,
    "邮箱验证码已发送": 428,
    "验证码有效时长30分钟, 失效请重新发送": 429,
    "组合条件": 430,
    "且": 431,
    "或": 432,
    "主题": 433,
    "字体": 434,
    "去除SKU字符": 435,
    "在前面": 436,
    "在后面": 437,
    "密码长度必须大于6位！": 438,
    "库存占用明细": 439,
    "设置不派单的特殊日期": 440,
    "时段": 441,
    "点击添加时间": 442,
    "结束": 443,
    "开始": 444,
    "中的结束日期不能小于开始日期！": 445,
    "选择每月盘点的日期": 446,
    "点击添加时间段": 447,
    "每月盘点日期设置": 448,
    "每日盘点时间设置": 449,
    "接单时间设置": 450,
    "营业时间设置": 451,
    "审核": 452,
    "取消审核": 453,
    "已作废": 454,
    "已盈亏": 455,
    "分货退货数量": 456,
    "已完成": 457,
    "修改单据备注": 458,
    "修改收货地址": 459,
    "加入黑名单": 460,
    "添加赠品": 461,
    "替换商品": 462,
    "修改备注": 463,
    "修改卖家备注": 464,
    "批量修改物流": 465,
    "记录发票": 466,
    "排序表单": 467,
    "订单明细": 468,
    "批量修改仓库": 469,
    "定金预售提前发货打标": 470,
    "批量替换商品": 471,
    "批量添加赠品": 472,
    "批量删除赠品": 473,
    "指定商品拆单": 474,
    "Hold单": 475,
    "入库单": 476,
    "会员加急发货打标": 477,
    "修改内部备注": 478,
    "零售发货单新增": 479,
    "请选择一条记录！": 480,
    "提示": 481,
    "请选择需要修改物流记录！": 482,
    "请选择需要修改发货仓库记录！": 483,
    "请选择需要修改备注的记录！": 484,
    "请选择需要修改内部备注的记录!": 485,
    "请选择需要定金预售提前发货的记录！": 486,
    "请选择需要加急发货的记录！": 487,
    "请选择需要替换商品的记录！": 488,
    "请选择需要添加赠品的记录！": 489,
    "请选择需要删除赠品的记录！": 490,
    "请选择需要拆单的记录！": 491,
    "请选择需要Hold单的记录！": 492,
    "请选择需要取消Hold单的记录！": 493,
    "是否确定取消Hold？": 494,
    "服务器请求失败": 495,
    "退货单新增": 496,
    "请选择需要复制的单据": 497,
    "请选择需要操作的单据！": 498,
    "批量替换下挂商品": 499,
    "只允许缺货或待审核状态的订单进行添加!": 500,
    "删除赠品": 501,
    "只允许缺货或待审核状态的订单进行添加！": 502,
    "请选择需要复制的单据！": 503,
    "售后复制": 504,
    "请先选择需要复制的订单": 505,
    "单据编号": 506,
    "失败原因": 507,
    "订单只能是原单才能复制！": 508,
    "非已取消或系统作废订单，不允许复制": 509,
    "只能对【仓库发货，平台发货】订单状态的原单进行复制操作": 510,
    "请选择一条需要复制的订单！": 511,
    "零售发货单详情": 512,
    "退换货订单新增": 513,
    "退货入库新增": 514,
    "订单拦截": 515,
    "释放库存": 516,
    "收藏": 517,
    "请至少选中一项！": 518,
    "请选择需要新增退单记录！": 519,
    "请选择需要开票的订单！": 520,
    "请选择需要取消的订单！": 521,
    "交易平台为当当，唯品会jitx，京东（货到付款）的订单不允许拆单": 522,
    "请选择需要缺货重新占单的记录！": 523,
    "请选择需要福袋缺货重新占单的记录！": 524,
    "请选择需要更改为平台发货的记录！": 525,
    "请选择要合并的单据！": 526,
    "请选择需要批量退单的记录！": 527,
    "请选择需要通知WMS的记录！": 528,
    "不支持批量操作！": 529,
    "请选中一项修改！": 530,
    "此退货入库单已经关闭匹配，不允许选择": 531,
    "是否确定批量原退？": 532,
    "只有等待售后确认状态可以强制完成！": 533,
    "是否确定强制完成？": 534,
    "退换货订单详情": 535,
    "取消状态不允许修改备注": 536,
    "单据状态是取消状态不能修改卖家备注！": 537,
    "此退换单状态不允许换货先发！": 538,
    "是否确定换货先发？": 539,
    "是否确定取消退单？": 540,
    "此退换货单已生成未作废的换货类型零售发货单，不允许取消，继续将作废换货类型零售发货单以及退换订单！": 541,
    "单据状态不符合取消条件，请重新选择": 542,
    "取消成功": 543,
    "申请数量与入库数量不一致，是否确定售后审核？": 544,
    "是否确定售后审核？": 545,
    "只有待售后审核状态的退单可以售后审核，请重新选择数据！": 546,
    "只有缺货状态订单允许缺货回传！": 547,
    "是否确定缺货回传订单！": 548,
    "开票通知编辑": 549,
    "是否确定取消订单？": 550,
    "扫描入库": 551,
    "此退换单状态不允许扫描入库,请重新选择!": 552,
    "一次只能对一个订单进行拆分！": 553,
    "订单拆分": 554,
    "只有待审核的订单可以合并": 555,
    "订单已经被HOLD，不允许合并！": 556,
    "订单为时效订单，不允许进行合并！": 557,
    "订单为预售订单且尾款未付，不允许合并！": 558,
    "合并订单最大支持合并50单！": 559,
    "确认将选中的订单合并吗？": 560,
    "成功": 561,
    "未合并的订单不允许进行取消合并！": 562,
    "只允许待审核的订单进行取消合并！": 563,
    "确认将选中的订单取消合并吗？": 564,
    "订单需要生成退换货单的订单状态不能已取消、系统作废！": 565,
    "订单需要发货后才能新增退单！": 566,
    "订单状态为仓库发货和平台发货才能新增退单！": 567,
    "请选择不超过80笔订单的数据！": 568,
    "只允许仓库发货、平台发货状态订单批量退单！": 569,
    "当前的操作会执行手动入库，是否继续？": 570,
    "虚拟仓库入库失败！": 571,
    "报错信息": 572,
    "选择的订单中存在非待审核订单,不允许释放库存！": 573,
    "是否确定将选择的订单占用的库存释放？": 574,
    "额外退款编辑": 575,
    "只有仓库发货或者平台发货的订单才能操作！": 576,
    "订单状态已审核，建议反审核再修改地址！": 577,
    "订单状态非未确认、缺货、已审核、配货中，不允许修改地址！": 578,
    "地址信息获取失败！": 579,
    "有一项导出正在进行中！": 580,
    "审核失败": 581,
    "多次缺货": 582,
    "缺货": 583,
    "请确认是否重传WMS？": 584,
    "只支持单个退货单做WMS撤回重做操作！": 585,
    "发货店仓": 586,
    "收货仓库": 587,
    "手机号不能为空！": 588,
    "手机号格式不正确！": 589,
    "收货人地址不能为空！": 590,
    "收货人地址格式不正确！": 591,
    "下单店铺": 592,
    "配送费用": 593,
    "平台单号": 594,
    "付款方式": 595,
    "代收金额": 596,
    "收货人": 597,
    "收货人手机": 598,
    "收货人省份": 599,
    "收货人市": 600,
    "收货人地址": 601,
    "不能为空！": 602,
    "手机号码必须为数字,请修改": 603,
    "实体仓库为必填项，请填写后保存！": 604,
    "实际赔付金额为必填项，请填写后保存！": 605,
    "支付方式不能为空！": 606,
    "原平台单号不能为空！": 607,
    "支付账号不能为空！": 608,
    "失败！": 609,
    "警告": 610,
    "新增": 611,
    "编辑": 612,
    "已提交": 613,
    "已结案": 614,
    "手机": 615,
    "嗨淘": 616,
    "TOP平台": 617,
    "普通淘宝": 618,
    "聚划算": 619,
    "正常": 620,
    "换货": 621,
    "补发": 622,
    "预售": 623,
    "虚拟": 624,
    "指定买赠": 625,
    "全场买赠": 626,
    "下单时间": 627,
    "定金时间": 628,
    "买家备注": 629,
    "卖家备注": 630,
    "不限制": 631,
    "限制": 632,
    "非搭配商品": 633,
    "搭配商品": 634,
    "选系统SKU": 635,
    "选平台SKU": 636,
    "选系统SPU": 637,
    "选平台SPU": 638,
    "包含以下商品": 639,
    "排除以下商品": 640,
    "数量阶梯": 641,
    "金额阶梯": 642,
    "不翻倍": 643,
    "翻倍": 644,
    "全部送": 645,
    "顺序送": 646,
    "随机送": 647,
    "买商品列表不同商品": 648,
    "买商品列表任意商品": 649,
    "指定商品总金额": 650,
    "订单总金额": 651,
    "单行单梯度数量": 652,
    "多梯度统一总量": 653,
    "复制成功！": 654,
    "商品SKU": 655,
    "商品款号": 656,
    "数量": 657,
    "请输入商品！": 658,
    "只能选取一条数据": 659,
    "不存在该商品！": 660,
    "弹框多选": 661,
    "该记录已在已选中列表中！": 662,
    "模板名称不能为空！": 663,
    "保存成功！": 664,
    "查询数量已超过上限，请修改查询条件！": 665,
    "请先选择": 666,
    "数据加载中...": 667,
    "暂无数据": 668,
    "导入": 669,
    "请选择需要导入的文件！": 670,
    "导入失败,详情见文件内容": 671,
    "文件最大64M！": 672,
    "标题": 673,
    "刷新": 674,
    "新增明细": 675,
    "删除明细": 676,
    "导出": 677,
    "组合福袋商品编辑": 678,
    "商品SPU": 679,
    "SKU快速生成": 680,
    "商品自定义属性": 681,
    "组合商品": 682,
    "商品分类": 683,
    "共享池库存梯度策略": 684,
    "配销仓库存梯度策略": 685,
    "寻源策略定义": 686,
    "店仓评分设置表": 687,
    "物流区域设置新增": 688,
    "零售发货单": 689,
    "退换货单": 690,
    "退货单详情": 691,
    "已发货退款单编辑": 692,
    "JIT配货单-换吊牌": 693,
    "退换货新增": 694,
    "促销活动": 695,
    "仓库物流优先级方案新增": 696,
    "快递赔付方案编辑": 697,
    "订单自动审核编辑": 698,
    "发货单派单规则": 699,
    "唯品会预警通知": 700,
    "档期日程规划": 701,
    "仓库物流设置": 702,
    "商品价格策略": 703,
    "直播解析策略": 704,
    "分仓规则": 705,
    "分物流规则": 706,
    "特殊物流方案": 707,
    "物流派送范围": 708,
    "HOLD单策略": 709,
    "天猫换货策略": 710,
    "审单策略": 711,
    "返回": 712,
    "保存": 713,
    "发票属性": 714,
    "请选中一条数据！": 715,
    "订单下载": 716,
    "接口下载任务表编辑": 717,
    "接口下载任务表": 718,
    "查询时间": 719,
    "订单状态": 720,
    "已审核": 721,
    "未发货取消": 722,
    "请输入平台单号": 723,
    "请选择订单状态": 724,
    "等待出库": 725,
    "多个平台单号，用逗号分隔": 726,
    "请选择输入的日期或输入订单编号": 727,
    "退单修改时间": 728,
    "服务单号": 729,
    "退单修改时间不存在时, 平台单号、服务单号必须同时有！": 730,
    "退单修改时间存在时,平台单号、服务单号必须为空！": 731,
    "退款申请时间": 732,
    "请输入退款申请时间！": 733,
    "新建": 734,
    "确认中": 735,
    "确认为JITX": 736,
    "确认为非JITX": 737,
    "请选择下单时间！": 738,
    "下单时间范围不能超过半小时，请重新设置！": 739,
    "请选择输入日期或输入订单编号": 740,
    "请输入平台修改时间或平台单号！": 741,
    "退单修改时间和退单单号不能同时为空": 742,
    "平台退款单号": 743,
    "换货单状态": 744,
    "换货待处理": 745,
    "换货单修改时间": 746,
    "平台换货单号": 747,
    "换单修改时间和换单单号不能同时为空": 748,
    "待发货": 749,
    "退单状态": 750,
    "待卖家同意": 751,
    "平台退货单号": 752,
    "平台时间": 753,
    "退供单号": 754,
    "多个退供单号，用逗号隔开": 755,
    "请输入平台时间或退供单号": 756,
    "商品数字ID": 757,
    "请输入需要下载的数字编号或修改时间中的一个": 758,
    "店铺和平台时间不能为空": 759,
    "PO编号": 760,
    "密码登录": 761,
    "验证码登录": 762,
    "欢迎登录": 763,
    "账号": 764,
    "密码": 765,
    "上传文件": 766,
    "数据正在导入中，请稍候...": 767,
    "订单下载任务已经发送，任务ID：": 768,
    "，请前往接口下载任务表查看下载进度！": 769,
    "查询结果": 770,
    "有效数据起始行": 771,
    "只能输入正整数": 772,
    "AK重复是否更新已有记录": 773,
    "注意：上传文件中，不要放置宏或图标，不要更改列的顺序，数据中不要使用公式。": 774,
    "下载模版": 775,
    "追加到原备注": 776,
    "日志服务请求失败!": 777,
    "隐藏当前列": 778,
    "重置所有列位置信息": 779,
    "全选": 780,
    "开启": 781,
    "点击此处，或标签页横向滚动切换": 782,
    "图例": 783,
    "提交状态": 784,
    "草稿状态": 785,
    "下线/过期状态": 786,
    "过期": 787,
    "换票类型": 788,
    "原发票信息": 789,
    "修改发票信息": 790,
    "收票信息": 791,
    "已选中{total}条数据": 792,
    "点击上传": 793,
    "已选中{num}条": 794,
    "所属大类": 795,
    "请输入SPU编码": 796,
    "编号": 797,
    "店仓编码": 798,
    "读入装箱标准": 799,
    "该记录已在已选中列表中": 800,
    "模板名称不能为空": 801,
    "查询数量已超过上限，请修改查询条件": 802,
    "加载中": 803,
    "文件名": 804,
    "导出位置": 805,
    "数据正在导入中，请稍候": 806,
    "下载报错信息": 807,
    "第{num}条记录报错": 808,
    "请选择要导入的文件": 809,
    "文件最大": 810,
    "退出全屏": 811,
    "退出": 812,
    "输入值不能大于{num}位数": 813,
    "该矩形框表示︰条码档案不存在该条码": 814,
    "信息筛选": 815,
    "请填写完整": 816,
    "已选条件": 817,
    "会员高级搜索": 818,
    "会员卡号": 819,
    "男": 820,
    "女": 821,
    "保密": 822,
    "会员类型/等级": 823,
    "开卡日期": 824,
    "地区": 825,
    "可用积分": 826,
    "是否关注公众号": 827,
    "未关注": 828,
    "已关注": 829,
    "已取关": 830,
    "微信小程序是否绑卡": 831,
    "微信会员卡是否绑卡": 832,
    "淘宝是否绑卡": 833,
    "会员标签": 834,
    "消费属性": 835,
    "最近一次消费日期": 836,
    "累计消费金额": 837,
    "消费次数": 838,
    "次": 839,
    "平均客单价": 840,
    "生命周期": 841,
    "新老会员": 842,
    "新会员": 843,
    "老会员": 844,
    "活跃程度": 845,
    "活跃会员": 846,
    "不活跃会员": 847,
    "沉睡会员": 848,
    "流失会员": 849,
    "搜索成功": 850,
    "标签分类": 851,
    "已选中": 852,
    "贴标签成功": 853,
    "请选择一种或多种": 854,
    "请选择会员类型": 855,
    "请选择会员等级": 856,
    "多个或": 857,
    "一个": 858,
    "已匹配到{num}位会员": 859,
    "请导入": 860,
    "导入成功{msg}位": 861,
    "开卡店仓": 862,
    "yyyy 年 MM 月 dd 日": 863,
    "(含）至": 864,
    "请选择累计月份": 865,
    "累计": 866,
    "近{num}个月": 867,
    "请添加标签": 868,
    "选择标签": 869,
    "请前往接口下载任务表查看下载进度！": 870,
    "手机位数不正确,请修改": 871,
    "请选择发货配销仓": 872,
    "请选择发货逻辑仓": 873,
    "条码明细中【数量】【退货价】只有在【单据状态】为【待审核】时才能编辑，现获取【单据状态(ORDER_STATUS)】失败！": 874,
    "订单取消成功": 875,
    "条失败": 876,
    "【商品素材】版本": 877,
    "更多筛选": 878,
    "筛选条件": 879,
    "添加条件": 880,
    "筛选结果": 881,
    "查看选中结果": 882,
    "全局检索": 883,
    "保存为模板": 884,
    "模板名称": 885,
    "选择文件": 886,
    "详细信息": 887,
    "是否确定作废选中的【{}】条卡号信息？": 888,
    "共{}条": 889,
    "时段{}中的{}时间不能为空！": 890,
    "其他": 891,
    "库存不足或商品已下架": 892,
    "申请时间已超7天无理由退换货时限": 893,
    "定制商品不支持换货": 894,
    "不符合商品完好标准": 895,
    "非包邮商品运费未达成一致": 896,
    "与买家达成一致": 897,
    "所换商品差价，未协商一致": 898,
    "批量签收": 899,
    "修改SN/IMEI信息": 900,
    "待交接": 901,
    "第{}条记录报错：": 902,
    "商品标签": 903,
    "不支持的文件格式'{type}'!": 904,
    "配货完成": 905,
    "LMA工单详情": 906,
    "换店": 907,
    "支付宝账户名称": 908,
    "下载方式": 909,
    "按日下载": 910,
    "按月下载": 911,
    "账单时间": 912,
    "请选择需要下载的支付宝账户名称": 913,
    "请选择需要下载的账单时间": 914,
    "节点类型": 915,
    "售中": 916,
    "售后": 917,
    "请选择节点类型！": 918,
    "费用类型": 919,
    "费用类型不能为空！": 920,
    "Accounting Treatment 不能为空！": 921,
    "失败!": 922,
    "手机号格式不正确!": 923,
    "发票种类": 924,
    "发票类型": 925,
    "输入平台单号后请回车": 926,
    "请选择需要申请换票的单据记录！": 927,
    "换票的单据只能选择一条订单发票！": 928,
    "选择的订单已经取消，不能申请换票！": 929,
    "选择的订单已经冻结，不能申请换票！": 930,
    "平台单号最多可添加20条！": 931,
    "该平台单号已添加！": 932,
    "对账日期": 933,
    "请选择需要分摊的逻辑调拨单范围": 934,
    "请选择需要分摊的零售发货单范围": 935,
    "请选择需要重算的对账单范围": 936,
    "请选择仓库": 937,
    "请选择对账日期": 938,
    "请勾选一条报价！": 939,
    "您勾选了无效的报价！": 940,
    "自动生成（PTZDDR—年+月+日+0001）": 941,
    "自动生成": 942,
    "平台订单导入编码": 943,
    "创建时间": 944,
    "所属店铺": 945,
    "所属平台": 946,
    "账单起始日期": 947,
    "账单截止日期": 948,
    "上账时间": 949,
    "账单文件类型": 950,
    "平台账单文件": 951,
    "通用账单文件": 952,
    "备注": 953,
    "仅支持导入csv、xlsx、xls格式的文件，请重新选择！": 954,
    "请选择所属店铺！": 955,
    "请选择账单起始日期！": 956,
    "请选择账单截止日期！": 957,
    "请选择上账时间！": 958,
    "备注长度不能大于200字符！": 959,
    "请选择需要下载的查询时间": 960,
    "下载失败": 961,
    "产生费用单": 962,
    "新增产生费用单": 963,
    "账单时间必须选择！": 964,
    "确认责任方": 965,
    "责任方": 966,
    "是否已收到赔付": 967,
    "单据业务类型编码": 968,
    "单据类型": 969,
    "订单": 970,
    "退单": 971,
    "单据类型不能为空！": 972,
    "单据编号不能为空！": 973,
    "指定总额": 974,
    "填写总额，系统按照此账单的个品项销售额占比分摊总额。": 975,
    "指定SKU": 976,
    "将总额分摊到指定的SKU上。": 977,
    "请填写正确的金额！": 978,
    "金额不能超过总金额的50% ！": 979,
    "请填写金额！": 980,
    "请填写指定的SKU！": 981,
    "条记录": 982,
    "暂未添加平台单号数据": 983,
    "发票信息": 984,
    "通用模板下载": 985,
    "更新文件": 986,
    "未选择任何文件": 987,
    "汇总年月不能为空": 988,
    "请求成功！": 989,
    "汇总年月": 990,
    "待拆列表": 991,
    "原始单号": 992,
    "客户": 993,
    "订单数量": 994,
    "拆单数量": 995,
    "查看发票不支持选择多条订单，只能选择一条查看!": 996,
    "请输入识别内容": 997,
    "请在输入后按回车": 998,
    "全部": 999,
    "待开票": 1000,
    "开票中": 1001,
    "已冻结": 1002,
    "已取消": 1003,
    "开票成功": 1004,
    "开票失败": 1005,
    "已冲红": 1006,
    "财审确认": 1007,
    "换纸质": 1008,
    "换专票": 1009,
    "换抬头": 1010,
    "电子发票": 1011,
    "纸质发票": 1012,
    "普票": 1013,
    "专票": 1014,
    "抬头类型": 1015,
    "个人": 1016,
    "企业": 1017,
    "发票抬头": 1018,
    "开票金额": 1019,
    "地址": 1020,
    "纳税人识别号": 1021,
    "电话号码": 1022,
    "开户银行": 1023,
    "银行账号": 1024,
    "发票备注": 1025,
    "收票人": 1026,
    "收票人地址": 1027,
    "邮箱": 1028,
    "仓库": 1029,
    "导入成功": 1030,
    "导入失败": 1031,
    "立即下载": 1032,
    "账单编码": 1033,
    "账单时间账单编码不能同时为空！": 1034,
    "账单时间不能为空": 1035,
    "账单时间不能跨月": 1036,
    "账单时间段天数要小于等于11天": 1037,
    "月结账单下载": 1038,
    "进度账单下载": 1039,
    "供应商ID": 1040,
    "生成": 1041,
    "供应商ID不能为空！": 1042,
    "账单编码不能为空": 1043,
    "店铺名称": 1044,
    "店铺名称不能为空！": 1045,
    "快递单号": 1046,
    "快递公司": 1047,
    "订单编号": 1048,
    "出库日期": 1049,
    "快递公司名称": 1050,
    "实体仓名称": 1051,
    "顾客电话不合法！": 1052,
    "财审": 1053,
    "客审": 1054,
    "丢件单": 1055,
    "上传凭证": 1056,
    "商品条码": 1057,
    "标准价": 1058,
    "实际成交价": 1059,
    "应付金额": 1060,
    "快递网点": 1061,
    "丢件类型": 1062,
    "丢件原因": 1063,
    "支付方式": 1064,
    "来源单据编号": 1065,
    "调整类型": 1066,
    "顾客姓名": 1067,
    "顾客电话": 1068,
    "会员昵称": 1069,
    "原单金额": 1070,
    "总应付金额": 1071,
    "原始出库日期": 1072,
    "责任人": 1073,
    "原因备注": 1074,
    "创建人": 1075,
    "修改人": 1076,
    "修改时间": 1077,
    "数量只能录入正整数！": 1078,
    "应收单价": 1079,
    "应付金额只能录入大于0的数字！": 1080,
    "日志内容": 1081,
    "操作姓名": 1082,
    "操作时间": 1083,
    "赔付单明细": 1084,
    "赔付原因": 1085,
    "已客审": 1086,
    "已财审": 1087,
    "基本信息": 1088,
    "保存失败！": 1089,
    "请选择明细后再点击删除": 1090,
    "丢件单新增": 1091,
    "作废": 1092,
    "查询条件设置": 1093,
    "单据状态": 1094,
    "赔付快递公司": 1095,
    "支付宝号": 1096,
    "客审时间": 1097,
    "客审人": 1098,
    "财审时间": 1099,
    "财审人": 1100,
    "作废时间": 1101,
    "作废人": 1102,
    "可用": 1103,
    "传DRP状态": 1104,
    "反客审成功！": 1105,
    "列表没有数据,无法导出！": 1106,
    "导出成功": 1107,
    "是否自动结算": 1108,
    "结算产生时间": 1109,
    "每天": 1110,
    "每月": 1111,
    "每年": 1112,
    "单据业务类型": 1113,
    "是否参与对账": 1114,
    "是否产生结算单": 1115,
    "结算类型": 1116,
    "首字符": 1117,
    "流水号位数": 1118,
    "参与对账单据类型": 1119,
    "日志": 1120,
    "修改的数据未保存,确定刷新": 1121,
    "结算类型不能为空, 请选择！": 1122,
    "结算单产生汇总方式": 1123,
    "结算单单号规则": 1124,
    "新增应付调整单明细": 1125,
    "收款账号": 1126,
    "请选着一条数据！": 1127,
    "丢件单详情": 1128,
    "平台单号不能为空！": 1129,
    "共{}件": 1130,
    "历史TP": 1131,
    "未定义": 1132,
    "快递仓储": 1133,
    "业审": 1134,
    "电子": 1135,
    "查询条件【平台店铺、平台条码ID、平台商品ID、条码、SPU编码、商品状态、同步状态、同步失败原因】至少选择一个！": 1136,
    "代收货款": 1137,
    "京东无界通用模板": 1138,
    "京东无界自营模板": 1139,
    "收件": 1140,
    "寄件": 1141,
    "服务": 1142,
    "签收人：": 1143,
    "时间：": 1144,
    "商家自定义区": 1145,
    "已视验": 1146,
    "客户信息": 1147,
    "客户签字": 1148,
    "应收金额": 1149,
    "请您确认包裹完好,保留此包裹联时,代表您已经正常签收并确认外包裹完好。http://www.jd-ex.com客服电话:400-603-3600": 1150,
    "查询条件 <实体仓> <单据日期> <来源单据类型> 至少有一个不为空.": 1151,
    "历史快照": 1152,
    "请输入需要同步的批次！": 1153,
    "批次号": 1154,
    "请输入批次号": 1155,
    "是否删除模板不存在记录": 1156,
    "绑定": 1157,
    "渠道层": 1158,
    "配销层": 1159,
    "聚合层": 1160,
    "逻辑层": 1161,
    "物理层": 1162,
    "请至少选择一个查询条件": 1163,
    "确定根据查询条件重传WMS?": 1164,
    "请输入驳回原因": 1165,
    "请输入内容": 1166,
    "配销仓": 1167,
    "选择日期": 1168,
    "设置库存同步的逻辑仓范围": 1169,
    "添加店仓": 1170,
    "下载导入模板": 1171,
    "请输入店仓名称": 1172,
    "收货店仓": 1173,
    "提交生成相应调拨单": 1174,
    "下载模板": 1175,
    "库存按查询条件同步": 1176,
    "商品按查询条件同步": 1177,
    "确定打印": 1178,
    "杭州": 1179,
    "打印": 1180,
    "正在打印中，请稍后。。。": 1181,
    "平台店铺": 1182,
    "请输入平台店铺": 1183,
    "请输入备注": 1184,
    "比例": 1185,
    "请输入配销仓": 1186,
    "请输入优先级": 1187,
    "共享池": 1188,
    "请输入共享池": 1189,
    "请输入共享池比例": 1190,
    "库存发布": 1191,
    "确认停用吗": 1192,
    "确认启用吗": 1193,
    "比例同步策略": 1194,
    "确认执行作废": 1195,
    "配销仓明细": 1196,
    "有一项导出正在进行中": 1197,
    "本次操作已后台处理，是否至[我的任务]查看": 1198,
    "数值越大，优先级越高": 1199,
    "结案": 1200,
    "请先选择需要删除的记录!": 1201,
    "确认执行审核？": 1202,
    "创建日期": 1203,
    "来源单号": 1204,
    "处理状态": 1205,
    "创建日期不能为空": 1206,
    "时间范围不能超过24小时": 1207,
    "【平台条码id、条码、批次编码】不能同时为空！": 1208,
    "批次编号": 1209,
    "店铺ID": 1210,
    "同步状态": 1211,
    "未审核": 1212,
    "是否错误": 1213,
    "同步库存数": 1214,
    "返回信息": 1215,
    "计算虚高库存前库存": 1216,
    "扩展属性": 1217,
    "平台商品ID不能为空！": 1218,
    "批次编号,平台商品ID,平台条码ID,条码编码中需最少一项不为空!": 1219,
    "平台店铺标题": 1220,
    "期初可售数": 1221,
    "变化数量": 1222,
    "期末可售数": 1223,
    "店铺不能为空！": 1224,
    "条码不能为空！": 1225,
    "清空条件": 1226,
    "下载平台商品": 1227,
    "下载平台库存": 1228,
    "是否确定全量库存同步": 1229,
    "当前选中记录无差异数，无需同步": 1230,
    "是否确认增量同步库存": 1231,
    "需要重新下载最新库存，不能产生增量同步": 1232,
    "是否确定修改同步比例": 1233,
    "平台商品": 1234,
    "是否转仓": 1235,
    "同步库存": 1236,
    "上架状态": 1237,
    "商品类型": 1238,
    "同步比例": 1239,
    "渠道内配销仓库存": 1240,
    "渠道外配销仓库存": 1241,
    "店铺库存": 1242,
    "中台系统当前店铺的库存": 1243,
    "计算状态": 1244,
    "平台库存": 1245,
    "线上平台当前店铺的库存": 1246,
    "平台库存下载时间": 1247,
    "差异数": 1248,
    "店铺库存 - 平台库存": 1249,
    "配销仓库存": 1250,
    "供货配销仓的可用库存的合计": 1251,
    "安全库存": 1252,
    "店铺当前平台条码ID的保底量": 1253,
    "最后同步数": 1254,
    "最后同步时间": 1255,
    "同步失败的原因": 1256,
    "平台条码": 1257,
    "传TMS失败": 1258,
    "传DRP失败": 1259,
    "传WMS失败": 1260,
    "WMS实缺": 1261,
    "当前平台单号存在多个零售发货单，请进入零售发货单页面查找查看": 1262,
    "打开": 1263,
    "生效": 1264,
    "已调度": 1265,
    "待发运": 1266,
    "在途": 1267,
    "签收": 1268,
    "已回单": 1269,
    "合计": 1270,
    "请输入调入量": 1271,
    "活动": 1272,
    "请选择商品类型": 1273,
    "来源配销仓": 1274,
    "配销仓类型": 1275,
    "来源仓库存": 1276,
    "占用数": 1277,
    "可用数": 1278,
    "来源聚合仓": 1279,
    "调入库存": 1280,
    "来源共享池": 1281,
    "请输入平台商品ID": 1282,
    "请选择修改时间": 1283,
    "计算完成": 1284,
    "计算中": 1285,
    "未同步": 1286,
    "同步成功": 1287,
    "同步失败": 1288,
    "未勾选记录，不允许继续操作": 1289,
    "操作成功": 1290,
    "共享池档案": 1291,
    "确认执行删除": 1292,
    "折扣": 1293,
    "是否保存已经修改的数据": 1294,
    "删除明细成功": 1295,
    "修改折扣成功": 1296,
    "请维护折扣！": 1297,
    "请维护价格！": 1298,
    "匹配成功": 1299,
    "请输入数量": 1300,
    "请先选择店仓": 1301,
    "单条码新增成功": 1302,
    "未开始": 1303,
    "导入中": 1304,
    "逻辑调拨": 1305,
    "非逻辑调拨": 1306,
    "逻辑调拨单批量导入": 1307,
    "聚合仓调拨单": 1308,
    "聚合仓到配销仓调拨单": 1309,
    "配销仓调拨单": 1310,
    "配销仓到聚合仓调拨单": 1311,
    "当前当前数据还在导入中，请稍后再次导入": 1312,
    "店仓": 1313,
    "创建拣货单": 1314,
    "来源平台": 1315,
    "范围时间": 1316,
    "请输入策略名称": 1317,
    "请输入范围时间": 1318,
    "评分策略": 1319,
    "请输入评分策略": 1320,
    "确认取消审核？": 1321,
    "该实体仓已存在!": 1322,
    "当前页有未保存数据，是否需要保存？": 1323,
    "确认执行结案": 1324,
    "来源平台和平台店铺不能均为空": 1325,
    "【仓优先】中\"\"实体仓\"\"为空，不允许保存!": 1326,
    "【仓优先】中\"\"优先级\"\"为空，不允许保存!": 1327,
    "请输入实体店仓": 1328,
    "库存同步": 1329,
    "判断条件": 1330,
    "开始值": 1331,
    "请先选择需要作废的记录！": 1332,
    "本次操作已后台处理，是否至[我的任务]查看?": 1333,
    "是否确认同步库存？": 1334,
    "是否打印选中行？": 1335,
    "驳回原因": 1336,
    "分货确认单": 1337,
    "共享库存": 1338,
    "独享库存": 1339,
    "查询条件": 1340,
    "独享库存明细": 1341,
    "共享库存明细": 1342,
    "生成盈亏": 1343,
    "盘点日期": 1344,
    "预盈亏明细按条码": 1345,
    "当前的操作会执行全量导出，导出时间可能会比较慢！是否继续导出？": 1346,
    "盘点店仓": 1347,
    "调整性质": 1348,
    "盘点类型": 1349,
    "全盘": 1350,
    "抽盘": 1351,
    "历史盘": 1352,
    "盈亏状态": 1353,
    "店仓名称": 1354,
    "预盈亏明细": 1355,
    "分类全盘": 1356,
    "未盈亏": 1357,
    "请选择店仓": 1358,
    "请选择类型": 1359,
    "请选择日期": 1360,
    "盈亏单": 1361,
    "生成盈亏后台处理中，请稍后查看盈亏结果": 1362,
    "盘盈": 1363,
    "盘亏": 1364,
    "串码": 1365,
    "停止/开启平台库存同步": 1366,
    "设定安全库存": 1367,
    "商家条码id": 1368,
    "来源聚合仓名称": 1369,
    "来源配销仓名称": 1370,
    "调入量": 1371,
    "修改商品标签": 1372,
    "修改同步比例": 1373,
    "收起列表": 1374,
    "显示列表": 1375,
    "收起矩阵": 1376,
    "显示矩阵": 1377,
    "批量修改折扣": 1378,
    "修改类型": 1379,
    "匹配在库": 1380,
    "匹配库存不足商品": 1381,
    "匹配可用": 1382,
    "发货可用": 1383,
    "发货在库": 1384,
    "在库": 1385,
    "收货可用": 1386,
    "收货在途": 1387,
    "零售数量": 1388,
    "行合计": 1389,
    "输入值不能大于4位数": 1390,
    "该矩形框表示︰条码档案不存在该条码！": 1391,
    "请输入SKU、SPU编码": 1392,
    "收货在库": 1393,
    "输入值不能大于7位数": 1394,
    "调拨类型": 1395,
    "导入状态": 1396,
    "发货方编码": 1397,
    "发货方名称": 1398,
    "收货方编码": 1399,
    "申请调拨数量": 1400,
    "实际调拨数量": 1401,
    "聚合调拨数量": 1402,
    "分货数量": 1403,
    "操作日期": 1404,
    "单据是否完成": 1405,
    "强制寻源规则": 1406,
    "仓优先": 1407,
    "新增行": 1408,
    "删除行": 1409,
    "总数量": 1410,
    "批次编号,平台商品ID,平台条码ID,条码中需最少一项不为空!": 1411,
    "分销": 1412,
    "请选择经营模式": 1413,
    "请输入逻辑仓": 1414,
    "客户寻源策略": 1415,
    "库存梯度": 1416,
    "输入开始值后，回车保存": 1417,
    "添加店铺明细": 1418,
    "删除库存梯度": 1419,
    "请输入判断条件和开始值": 1420,
    "请在输入框“开始值”回车保存": 1421,
    "请输入店铺和比例": 1422,
    "点击【保存】后落库": 1423,
    "当前没有可清空的店仓！": 1424,
    "确认清空所有店仓？": 1425,
    "匹配": 1426,
    "当前页面是{}，确定切换为其他调拨类型吗？": 1427,
    "已选中{}条数据": 1428,
    "寻源优先级": 1429,
    "请输入配销仓比例": 1430,
    "确认执行结案？": 1431,
    "修改商品类型": 1432,
    "全量库存同步": 1433,
    "是否确定全量库存同步？": 1434,
    "手动增量同步库存": 1435,
    "是否确定修改同步比例？": 1436,
    "下载全店在售库存": 1437,
    "全量同步全店库存（在售）": 1438,
    "保存成功": 1439,
    "指定店铺": 1440,
    "公共": 1441,
    "请选择来源平台": 1442,
    "平台店铺为空，不允许保存！": 1443,
    "确认执行库存同步？": 1444,
    "盘点性质": 1445,
    "指定商品比例同步策略": 1446,
    "实际盘点数量": 1447,
    "收货逻辑仓": 1448,
    "实体仓逻辑": 1449,
    "零售开始时间": 1450,
    "零售结束时间": 1451,
    "销售类型": 1452,
    "发货逻辑仓": 1453,
    "是否确认同步页面": 1454,
    "订单正向": 1455,
    "订单逆向": 1456,
    "已选择的任务": 1457,
    "信息类型": 1458,
    "类型划分": 1459,
    "任务分类": 1460,
    "任务名称": 1461,
    "任务说明": 1462,
    "主数据": 1463,
    "中台系统监控": 1464,
    "选择任务": 1465,
    "更新时间": 1466,
    "对外接口监控": 1467,
    "信息推送": 1468,
    "信息接收": 1469,
    "信息取消": 1470,
    "信息回传": 1471,
    "中台": 1472,
    "暂无异常数据": 1473,
    "最近菜单": 1474,
    "添加常用菜单": 1475,
    "搜索菜单的名称": 1476,
    "你可能想添加": 1477,
    "预警": 1478,
    "更新": 1479,
    "今日数据": 1480,
    "通知消息": 1481,
    "默认": 1482,
    "柱状图": 1483,
    "即将超时订单": 1484,
    "超时订单": 1485,
    "待拦截订单": 1486,
    "售后传wms异常单": 1487,
    "售后异常": 1488,
    "待售后审核": 1489,
    "单数": 1490,
    "通知": 1491,
    "链接": 1492,
    "营销活动": 1493,
    "任务详细说明": 1494,
    "最多只能选择{}个任务": 1495,
    "公告信息": 1496,
    "公告": 1497,
    "尺码": 1498,
    "唯品会专配": 1499,
    "顺丰陆运": 1500,
    "航空禁运": 1501,
    "入库单结单时间": 1502,
    "异常类型": 1503,
    "省": 1504,
    "市": 1505,
    "平台类型": 1506,
    "平台省市区": 1507,
    "卡单原因": 1508,
    "卡单时间": 1509,
    "卡单原因不能为空": 1510,
    "错误信息": 1511,
    "备注内容不能全是空格！": 1512,
    "非唯品会专配": 1513,
    "唯品会入库单不能为空": 1514,
    "请选择预计发货时间": 1515,
    "请选择预计到货时间": 1516,
    "到货时间小于预计发货时间": 1517,
    "修改成功": 1518,
    "请勾选需要处理的异常商品": 1519,
    "规格1": 1520,
    "规格2": 1521,
    "此商品中不存在该规格1和规格2": 1522,
    "正品": 1523,
    "仓库名称": 1524,
    "入库实体仓库": 1525,
    "请选择仓库!": 1526,
    "平台规格ID": 1527,
    "平台商品ID": 1528,
    "平台商品名称": 1529,
    "系统SKU编码": 1530,
    "商家商品编码": 1531,
    "商家规格编码": 1532,
    "系统SKU名称": 1533,
    "规格": 1534,
    "是否为赠品": 1535,
    "请添加并选择替换商品！": 1536,
    "可录入多个拣货单号，用逗号分隔": 1537,
    "物流公司不能为空!": 1538,
    "覆盖原备注": 1539,
    "JIT配货单": 1540,
    "拣货单号": 1541,
    "原始条码": 1542,
    "实际条码": 1543,
    "拣货数": 1544,
    "撤回": 1545,
    "替换": 1546,
    "实际条码为空或不正确": 1547,
    "数量不能为空": 1548,
    "数量格式不正确": 1549,
    "实际条码的总拣货数超过了原始条码的拣货数": 1550,
    "请选择需要删除明细": 1551,
    "当前无任何修改，不执行保存！": 1552,
    "手机号不能为空!": 1553,
    "收货人地址不能为空!": 1554,
    "收货人地址格式不正确!": 1555,
    "平台业务类型": 1556,
    "发货仓库": 1557,
    "收货人邮费": 1558,
    "收件人公司": 1559,
    "收件人门牌号": 1560,
    "添加商品SKU": 1561,
    "颜色": 1562,
    "SPU名称": 1563,
    "可用库存": 1564,
    "原成交单价": 1565,
    "服务费": 1566,
    "下单店铺不允许为空，请选择下单店铺！": 1567,
    "请选择要删除的明细！": 1568,
    "收货人地址格式不正确,": 1569,
    "街道/乡镇": 1570,
    "邮编": 1571,
    "请选择需要更换商品记录！": 1572,
    "只能选择一条商品记录！": 1573,
    "派件": 1574,
    "揽收": 1575,
    "退回": 1576,
    "退签": 1577,
    "转投": 1578,
    "疑难": 1579,
    "清关": 1580,
    "拒签": 1581,
    "传WMS成功": 1582,
    "未虚拟入库": 1583,
    "虚拟入库已入库": 1584,
    "平台退款单号:": 1585,
    "退单时间:": 1586,
    "收货人邮编": 1587,
    "终止入库数量": 1588,
    "平台退货金额": 1589,
    "单件换货金额": 1590,
    "等待入库确认": 1591,
    "退货单": 1592,
    "批量修改地址": 1593,
    "财": 1594,
    "订单无需财审！": 1595,
    "请选择需要反审核并卡单的记录！": 1596,
    "请选择需要的记录！": 1597,
    "待审核": 1598,
    "订单状态不是【待审核】，不允许重新寻物流！": 1599,
    "最多可勾选20条单据！": 1600,
    "选择的订单中存在JITX订单, 不允许添加赠品！": 1601,
    "退换货单新增": 1602,
    "工单": 1603,
    "复制订单": 1604,
    "重新分配快递": 1605,
    "重新分配仓库": 1606,
    "请选择需要拆单的单据记录！": 1607,
    "您勾选的订单业务类型不正确或者状态不符合要求": 1608,
    "您选择的订单不是周期购订单，不允许修改！": 1609,
    "请选择需要修改的记录！": 1610,
    "不允许批量修改预计发货时间！": 1611,
    "标签": 1612,
    "申请发票": 1613,
    "反审核": 1614,
    "多包裹": 1615,
    "卡": 1616,
    "异常": 1617,
    "复": 1618,
    "补": 1619,
    "预": 1620,
    "合": 1621,
    "出库通知单单号的id为空": 1622,
    "未通知": 1623,
    "通知中": 1624,
    "已通知": 1625,
    "取消中": 1626,
    "取消失败": 1627,
    "有效订单": 1628,
    "拆单原因": 1629,
    "预售类型": 1630,
    "请选择需要打标的订单记录！": 1631,
    "系统作废": 1632,
    "状态已取消或作废，不能打标！": 1633,
    "自定义订单标签": 1634,
    "查询无结果，请隔段时间再查": 1635,
    "当前物流单号还未有物流轨迹信息，请稍后再查！": 1636,
    "请谨慎操作，执行后会影响WMS的在途库存数量！是否确认继续执行？": 1637,
    "是否确认操作SIGN转ADD？": 1638,
    "订单只能是原单才能补发！": 1639,
    "非已取消或系统作废订单，不允许补发！": 1640,
    "只能对【仓库发货，平台发货】订单状态的原单进行补发操作！": 1641,
    "【仓库发货、平台发货、取消/作废】的单据，不允许执行【审核】操作！": 1642,
    "信息": 1643,
    "审核当前勾选订单": 1644,
    "合并订单并审核": 1645,
    "请选择需要强制审核的记录！": 1646,
    "【仓库发货、平台发货、取消/作废】的单据，不允许执行【反审核】操作！": 1647,
    "货到付款": 1648,
    "非预售": 1649,
    "预售尾款已付": 1650,
    "合并订单": 1651,
    "取消合并订单": 1652,
    "时间": 1653,
    "操作": 1654,
    "只允许仓库发货、平台发货状态订单批量退单": 1655,
    "请输入拆单原因": 1656,
    "请选择需要修改的单据记录！": 1657,
    "确定执行订单业务类型修改？": 1658,
    "请选择需要卡单的数据": 1659,
    "搜索": 1660,
    "关闭": 1661,
    "条码": 1662,
    "是否赠品": 1663,
    "国标码": 1664,
    "销售价": 1665,
    "是否可拆单": 1666,
    "不可售": 1667,
    "库存数": 1668,
    "当前展示的库存数为订单的店铺和实体关联的逻辑仓下良品仓的可用库存数量汇总": 1669,
    "拆分数量只能为正整数": 1670,
    "未查询到数据": 1671,
    "单据来源": 1672,
    "手动": 1673,
    "单据日期": 1674,
    "平台状态": 1675,
    "业务类型": 1676,
    "业务单据": 1677,
    "平台商品编码": 1678,
    "规格名称": 1679,
    "可退金额": 1680,
    "已发货退款单": 1681,
    "日志明细请求失败": 1682,
    "平台赠品": 1683,
    "系统赠品": 1684,
    "退款原因": 1685,
    "判责方": 1686,
    "退款金额": 1687,
    "确定原始订单编号::": 1688,
    "保存出错": 1689,
    "原始订单编号": 1690,
    "判责方备注": 1691,
    "自动": 1692,
    "发货单": 1693,
    "买家昵称": 1694,
    "买家手机号": 1695,
    "原始平台单号": 1696,
    "支付账号": 1697,
    "赠品": 1698,
    "成交金额": 1699,
    "购买数量": 1700,
    "可退数量": 1701,
    "普通商品": 1702,
    "预售商品": 1703,
    "未拆分的组合商品": 1704,
    "轻供商品": 1705,
    "其它": 1706,
    "用户名称": 1707,
    "创建人姓名": 1708,
    "同意退款": 1709,
    "退款完成": 1710,
    "拒绝退款": 1711,
    "确认": 1712,
    "选择退款单据": 1713,
    "收款方账号": 1714,
    "打款失败原因": 1715,
    "中台业务类型": 1716,
    "请先选中一条要操作的单据！": 1717,
    "当前选中的单据明细行为空 或 明细行中的\")可退金额(RETURNABLE_AMOUNT)t(\"等于0，请重新选择！": 1718,
    "图片凭证最多添加10张图片": 1719,
    "请先选择退款单据！": 1720,
    "请选择要退款的明细！": 1721,
    "平台退款状态": 1722,
    "平台退款原因": 1723,
    "平台退款说明": 1724,
    "生成退单": 1725,
    "原始单据编号": 1726,
    "条码编码": 1727,
    "商品编码": 1728,
    "请选择生成退单的订单明细": 1729,
    "明细退款金额不能为空": 1730,
    "明细退款金额总和与总退款金额不一致": 1731,
    "退款原因请求失败": 1732,
    "批量导入": 1733,
    "提前换货": 1734,
    "换货转退货": 1735,
    "从WMS撤回": 1736,
    "门店一键入库": 1737,
    "同步通用平台状态": 1738,
    "是否确定同步通用平台状态？": 1739,
    "终止入库": 1740,
    "待确认": 1741,
    "待传WMS": 1742,
    "待退货入库": 1743,
    "未传WMS": 1744,
    "WMS撤回": 1745,
    "入库确认": 1746,
    "重传WMS": 1747,
    "无需传": 1748,
    "待传": 1749,
    "传成功": 1750,
    "传失败": 1751,
    "线下处理完成": 1752,
    "退单ID": 1753,
    "等待退货入库": 1754,
    "已揽收": 1755,
    "请选中一项确认!": 1756,
    "退换货单没有物流单号，是否确认？": 1757,
    "只有等待入库确认状态的退单可以入库确认，请重新选择数据！": 1758,
    "是否确定入库确认？": 1759,
    "入库确认成功": 1760,
    "此退换货单已生成未作废的换货类型零售发货单,不允许取消,继续将作废换货类型零售发货单以及退换订单": 1761,
    "未确认": 1762,
    "只有“确认状态”为未确认，才可以修改!": 1763,
    "WMS手动撤回失败！": 1764,
    "单据未全部入库，是否执行强制完成？": 1765,
    "是否确定批量申请补充物流信息": 1766,
    "只有“确认状态”为未确认，才能进行退转换操作": 1767,
    "转换失败": 1768,
    "平台信息": 1769,
    "查询物流轨迹": 1770,
    "补寄": 1771,
    "预留库存": 1772,
    "勾选后，退换货单保存成功后会生成零售发货单并寻源占库存，不勾选则会待仓库入库完成后才生成零售发货单": 1773,
    "原单买家备注": 1774,
    "原单卖家备注": 1775,
    "传奶卡状态": 1776,
    "是否错发": 1777,
    "质检状态": 1778,
    "未通过": 1779,
    "通过": 1780,
    "确认状态": 1781,
    "确认人": 1782,
    "确认时间": 1783,
    "虚拟入库状态": 1784,
    "入库时间": 1785,
    "终止状态": 1786,
    "部分": 1787,
    "终止入库时间": 1788,
    "入库确认人": 1789,
    "入库确认时间": 1790,
    "传AG状态": 1791,
    "WMS单据编号": 1792,
    "传WMS状态": 1793,
    "WMS撤回状态": 1794,
    "传WMS失败次数": 1795,
    "传WMS失败原因": 1796,
    "收货人省": 1797,
    "收货人街道": 1798,
    "实物商品": 1799,
    "SN信息": 1800,
    "一键入库": 1801,
    "换货人信息解密": 1802,
    "申请数量不允许大于可退数量!": 1803,
    "终止数量": 1804,
    "错发条码": 1805,
    "未查询到条码!": 1806,
    "不允许出现条码一致的明细!": 1807,
    "店铺名称不允许为空，请选择下单店铺！": 1808,
    "请输入sku、款号": 1809,
    "等待退货入库且传WMS成功状态的单据不可修改！": 1810,
    "取消状态单据无法修改!": 1811,
    "原始单据编号不能为空!": 1812,
    "退回物流公司 及 退回物流公司ID（CP_C_LOGISTICS_ID）不能为空！": 1813,
    "退款原因不能为空": 1814,
    "退回物流单号不能为空": 1815,
    "入库实体仓库不能为空": 1816,
    "无次品调拨": 1817,
    "次品已调拨": 1818,
    "次品未调拨": 1819,
    "退货明细存在申请数量为0的数据，不能保存，请检查处理！": 1820,
    "退货明细存在申请数量为负的数据，不能保存，请检查处理！": 1821,
    "退货明细颜色不能为空": 1822,
    "退货明细尺码不能为空": 1823,
    "在“单据类型=退货”且“退款原因=发错货”时，“是否错发”强制开启，且“错发条码”必填，且不能跟原SKU编码一样！": 1824,
    "换货明细颜色不能为空": 1825,
    "换货明细尺码不能为空": 1826,
    "请输入SN码！": 1827,
    "未拣货数量": 1828,
    "通知数": 1829,
    "已拣货数": 1830,
    "箱号": 1831,
    "清空": 1832,
    "已审核订单不允许清空": 1833,
    "已作废订单不允许清空": 1834,
    "查看未扫描商品": 1835,
    "是否箱": 1836,
    "扫描数量": 1837,
    "配码": 1838,
    "尺寸": 1839,
    "吊牌价": 1840,
    "通知数量": 1841,
    "已拣货数量": 1842,
    "出库通知单号": 1843,
    "拣货箱号": 1844,
    "装箱数量": 1845,
    "出库结果单号": 1846,
    "发货方": 1847,
    "收货方": 1848,
    "审核人": 1849,
    "审核时间": 1850,
    "最后一箱，不允许删除!": 1851,
    "已审核订单不允许修改": 1852,
    "已作废订单不允许修改": 1853,
    "商品不能为空!": 1854,
    "扫描数量不能为空!": 1855,
    "明细不存在!": 1856,
    "当前单据未保存,不允许审核!": 1857,
    "入库通知单号": 1858,
    "入库结果单号": 1859,
    "明细不存在": 1860,
    "发出条码": 1861,
    "发出条码不能为空": 1862,
    "SKU编码": 1863,
    "条形码": 1864,
    "退回物流公司": 1865,
    "退回物流单号": 1866,
    "提货人": 1867,
    "提货人手机": 1868,
    "拒单原因": 1869,
    "拒单原因说明": 1870,
    "营业员工号": 1871,
    "营业员姓名": 1872,
    "最晚发货时间": 1873,
    "预计送达时间": 1874,
    "电子面单状态": 1875,
    "获取电子面单失败原因": 1876,
    "取消电子面单失败原因": 1877,
    "收货人电话": 1878,
    "区": 1879,
    "详细地址": 1880,
    "配送方式": 1881,
    "物流单号": 1882,
    "是否通知发货方入库": 1883,
    "发货方入库状态": 1884,
    "商品名称": 1885,
    "完整": 1886,
    "不完整": 1887,
    "规格属性": 1888,
    "商品信息完整度": 1889,
    "是否需要发布": 1890,
    "发布状态": 1891,
    "发布成功/失败时间": 1892,
    "失败原因/备注": 1893,
    "发布时间": 1894,
    "发布失败原因": 1895,
    "分发": 1896,
    "请先选择需要修改的记录": 1897,
    "修改商品信息": 1898,
    "待发布": 1899,
    "发布成功": 1900,
    "发布失败": 1901,
    "部分失败": 1902,
    "部分待发": 1903,
    "部分待发&失败": 1904,
    "分发成功": 1905,
    "待分发": 1906,
    "分发失败": 1907,
    "赠品标记": 1908,
    "规格3": 1909,
    "成交单价": 1910,
    "零售发货单单号": 1911,
    "申请退货数量": 1912,
    "退货单价": 1913,
    "退货金额": 1914,
    "换货数量": 1915,
    "请勾选ID": 1916,
    "只能勾选单个ID": 1917,
    "订单已审核，不允许添加赠品记录，建议反审核再进行修改！": 1918,
    "当前状态异常，不允许添加赠品！": 1919,
    "该订单为JITX订单, 不允许添加赠品！": 1920,
    "标记退款完成": 1921,
    "标记取消退款": 1922,
    "当前订单状态不允许明细备注！": 1923,
    "只能选择一条修改备注的记录！": 1924,
    "赠品拆单方式": 1925,
    "效期类型": 1926,
    "生产日期范围": 1927,
    "生产天数范围": 1928,
    "生产日期和数量": 1929,
    "效期范围": 1930,
    "商品规格": 1931,
    "商品重量(KG)": 1932,
    "商品总重量(KG)": 1933,
    "性别": 1934,
    "缺货数量": 1935,
    "实物报缺": 1936,
    "赠品挂靠关系": 1937,
    "赠品类型": 1938,
    "价格": 1939,
    "平台售价": 1940,
    "结算单价": 1941,
    "结算金额": 1942,
    "商品优惠分摊": 1943,
    "调整金额": 1944,
    "平台补贴金额": 1945,
    "订单优惠分摊": 1946,
    "实付金额": 1947,
    "购物金核销子订单权益金分摊金额": 1948,
    "购物金核销子订单本金分摊金额": 1949,
    "取消状态": 1950,
    "买家已经申请退款，等待卖家同意": 1951,
    "卖家已经同意退款，等待买家退货": 1952,
    "买家已经退货，等待卖家确认收货": 1953,
    "卖家拒绝退款": 1954,
    "退款关闭": 1955,
    "退款成功": 1956,
    "分销金额": 1957,
    "直播来源": 1958,
    "直播主体": 1959,
    "配合主体": 1960,
    "直播场次": 1961,
    "促销编码": 1962,
    "子订单编号": 1963,
    "预计发货时间": 1964,
    "赠品发货节点": 1965,
    "赠品发货间隔时长(小时)": 1966,
    "促销活动名称": 1967,
    "促销活动编码": 1968,
    "直播相关信息": 1969,
    "主播名称": 1970,
    "其它扩展信息": 1971,
    "购物金本金分摊金额": 1972,
    "购物金权益金分摊金额": 1973,
    "此商品中不存在该规格": 1974,
    "订单ID": 1975,
    "单据编号:": 1976,
    "合并平台单号:": 1977,
    "平台订单名称": 1978,
    "交易平台": 1979,
    "预售尾款未付": 1980,
    "是否传SAP:": 1981,
    "传SAP状态:": 1982,
    "打包状态:": 1983,
    "未打包": 1984,
    "已打包": 1985,
    "是否打印礼品卡:": 1986,
    "礼品收送人:": 1987,
    "礼品发送人:": 1988,
    "礼品卡内容:": 1989,
    "会员编码:": 1990,
    "预计发货时间:": 1991,
    "业务类型:": 1992,
    "订单来源系统:": 1993,
    "交易来源平台单号:": 1994,
    "原单店铺:": 1995,
    "期数:": 1996,
    "异常订单": 1997,
    "待寻源": 1998,
    "已确认收货": 1999,
    "交易完成": 2000,
    "预售待发货": 2001,
    "预售缺货": 2002,
    "退单编号查询": 2003,
    "退换货单号": 2004,
    "原单单号": 2005,
    "收货人手机号": 2006,
    "实体仓库": 2007,
    "是否手工新增": 2008,
    "退货批次": 2009,
    "入库仓库": 2010,
    "手机号": 2011,
    "姓名": 2012,
    "特殊处理类型": 2013,
    "发件地址": 2014,
    "退单编号": 2015,
    "此明细已经匹配，不允许修改退换货单号！": 2016,
    "入库单商品明细": 2017,
    "退货入库日志": 2018,
    "实收条码": 2019,
    "商品标记": 2020,
    "是否匹配": 2021,
    "是否生成调整单": 2022,
    "是否无原单条码": 2023,
    "实际发出条码": 2024,
    "处理人": 2025,
    "处理人备注": 2026,
    "入库单单号": 2027,
    "退货批次必填！": 2028,
    "特殊处理类型必填！": 2029,
    "请输入查询条件！": 2030,
    "请选择一条数据！": 2031,
    "批量接单": 2032,
    "去拣货": 2033,
    "批量呼叫快递": 2034,
    "批量发货": 2035,
    "批量导出": 2036,
    "交接给物流": 2037,
    "接单": 2038,
    "呼叫快递": 2039,
    "拒单": 2040,
    "查看包裹详情": 2041,
    "装箱复核": 2042,
    "打印装箱单": 2043,
    "发货": 2044,
    "核销": 2045,
    "拒单处理": 2046,
    "核销处理": 2047,
    "待接单": 2048,
    "已发货": 2049,
    "拣货中": 2050,
    "已拣货": 2051,
    "全部复核": 2052,
    "部分复核": 2053,
    "单据已呼叫过快递，不允许重复呼叫": 2054,
    "单据已接单，不允许重复接单": 2055,
    "发货处理": 2056,
    "您需要勾选单据状态不是“待发货”或者没有接单！": 2057,
    "打印拣货单": 2058,
    "打印交接单": 2059,
    "平台店铺昵称": 2060,
    "售后类型": 2061,
    "售后申请日期": 2062,
    "售后原因": 2063,
    "售后原因说明": 2064,
    "请输入收货人": 2065,
    "请输入收货人手机": 2066,
    "请选择收货人省份": 2067,
    "请选择收货人市": 2068,
    "请选择收货人区": 2069,
    "请输入收货人地址": 2070,
    "申请数量": 2071,
    "申请数量不能大于可退数量！": 2072,
    "单件退款金额": 2073,
    "换货平台条码ID": 2074,
    "请选择售后类型": 2075,
    "请勾选订单明细": 2076,
    "勾选订单明细的换货平台条码ID不能为空": 2077,
    "勾选订单明细的申请数量必填，且不能大于可退数量": 2078,
    "对等换货策略": 2079,
    "请选中一条单据！": 2080,
    "确认执行": 2081,
    "销售数量": 2082,
    "换货商品": 2083,
    "换货商品名称": 2084,
    "对等商品": 2085,
    "对等商品名称": 2086,
    "对等数量": 2087,
    "请填写物流单号！": 2088,
    "标记管理": 2089,
    "标记说明": 2090,
    "不可超过6个汉字": 2091,
    "请选择需要添加的标记!": 2092,
    "请选择需要取消的标记": 2093,
    "标记说明不能为空!": 2094,
    "复制原因": 2095,
    "丢件复制": 2096,
    "错漏发复制": 2097,
    "赠品复制": 2098,
    "请选择复制原因！": 2099,
    "换吊牌后条码": 2100,
    "请选择打标的标签": 2101,
    "请选择需要取消的标签": 2102,
    "请选择要操作的标签！": 2103,
    "请输入正确的预计发货时间！": 2104,
    "预计到货时间": 2105,
    "补差单号": 2106,
    "请录入OM单号并回车！": 2107,
    "补差金额": 2108,
    "补发订单编号": 2109,
    "请录入OM单号并回车!": 2110,
    "修改物流单号": 2111,
    "请选择预计发货时间！": 2112,
    "修改传WMS拣货单字段": 2113,
    "选择导入模板": 2114,
    "选择导入页签": 2115,
    "请选择导入模板": 2116,
    "请选择导入页签": 2117,
    "请选择选择导入模板或导入页签": 2118,
    "请选择需要修改店铺的单据记录！": 2119,
    "单据已转入，不能修改！": 2120,
    "请选择店铺！": 2121,
    "只支持【退款失败】的额外退款单单据进行退款失败处理！": 2122,
    "流水号": 2123,
    "请输入流水号！": 2124,
    "预计发货时间不能为空！": 2125,
    "预计发货时间不能小于当前时间！": 2126,
    "预览": 2127,
    "上传": 2128,
    "送礼人姓名": 2129,
    "请输入送礼人名称": 2130,
    "收礼人姓名": 2131,
    "请输入收礼人名称": 2132,
    "赠言": 2133,
    "请输入赠言": 2134,
    "礼品卡图片": 2135,
    "卡类型": 2136,
    "卡号": 2137,
    "异常商品": 2138,
    "替换异常商品": 2139,
    "当前记录已审核，不允许替换商品明细！": 2140,
    "当前记录已不存在！": 2141,
    "请先选择需要替换商品的记录！": 2142,
    "选择的商品包含正常商品，是否确认要替换！": 2143,
    "是否确定导出选中的主子表数据?": 2144,
    "收货人城市:": 2145,
    "商品编号": 2146,
    "生产月份": 2147,
    "生产日期": 2148,
    "可用量": 2149,
    "在库量": 2150,
    "占用量": 2151,
    "冻结量": 2152,
    "在途量": 2153,
    "来源单类型": 2154,
    "逻辑占用单据编号": 2155,
    "占用数量": 2156,
    "占用库存": 2157,
    "差异量": 2158,
    "到货天数": 2159,
    "零担费用": 2160,
    "调拨费用": 2161,
    "总费用": 2162,
    "逻辑占用单号": 2163,
    "收货人城市": 2164,
    "占单结果查询": 2165,
    "逻辑占用明细": 2166,
    "物流或仓库不能为空": 2167,
    "重新占单": 2168,
    "暂无可提交数据": 2169,
    "生产日期不可为空！": 2170,
    "占用数量不可为空！": 2171,
    "非赠品": 2172,
    "是否组合下挂": 2173,
    "实际退货数量": 2174,
    "申请退款金额": 2175,
    "请选择至少一条明细！": 2176,
    "关联原单": 2177,
    "发货状态": 2178,
    "未发货": 2179,
    "部分发货": 2180,
    "全部发货": 2181,
    "订单信息": 2182,
    "收货人信息": 2183,
    "配货信息": 2184,
    "支付信息": 2185,
    "顾客拒收后发货方入库信息": 2186,
    "买家下单": 2187,
    "买家付款": 2188,
    "商品出库": 2189,
    "买家确认收货": 2190,
    "通知发货方入库": 2191,
    "图片": 2192,
    "支付金额": 2193,
    "全渠道订单": 2194,
    "总扫描数量": 2195,
    "选择入库的物流包裹": 2196,
    "物流单号不一致不允许合并入库，选择其中一个包裹入库": 2197,
    "入库": 2198,
    "扫描单号": 2199,
    "支持物流单号、平台单号": 2200,
    "删除": 2201,
    "残次": 2202,
    "已入库数量": 2203,
    "商品信息": 2204,
    "错发商品": 2205,
    "清空当前未完成单据继续扫描下一张单据？": 2206,
    "请扫描单号查询": 2207,
    "是否清空当前未完成单据继续扫描下一张单据？": 2208,
    "未找到退货单据，请联系店铺客服": 2209,
    "请输入商品SKU": 2210,
    "您扫描的商品不在退货单中！": 2211,
    "物流单号为空，不允许入库": 2212,
    "商品为空，不允许入库": 2213,
    "商品未扫描，不允许入库": 2214,
    "是否确认执行入库？": 2215,
    "请选择单据": 2216,
    "物流单号不一致": 2217,
    "退单信息": 2218,
    "退单物流信息": 2219,
    "明细": 2220,
    "提交申请": 2221,
    "待收货": 2222,
    "已收货": 2223,
    "全渠道退货扫描单": 2224,
    "扫描商品": 2225,
    "全渠道退货单": 2226,
    "请选择单据！": 2227,
    "是否确认取消快递单号？": 2228,
    "包裹详情": 2229,
    "包": 2230,
    "裹": 2231,
    "单据编号(OM)": 2232,
    "已拒单": 2233,
    "拒单时间": 2234,
    "配送信息": 2235,
    "发货操作": 2236,
    "系统将生成物流交接单，是否确定？": 2237,
    "请输入营业员工号": 2238,
    "确定并打印交接单": 2239,
    "接单状态": 2240,
    "已接单": 2241,
    "接单时间": 2242,
    "发货时间": 2243,
    "该包裹物流单号为空，不允许打印！": 2244,
    "包裹信息维护": 2245,
    "拣": 2246,
    "退": 2247,
    "收起": 2248,
    "展开": 2249,
    "待提货": 2250,
    "已提货": 2251,
    "核销时间": 2252,
    "请输入查询条件进行搜索": 2253,
    "收货人手机格式不正确！": 2254,
    "当前选中行没有物流单号！": 2255,
    "寻源日志": 2256,
    "仓库可用量": 2257,
    "分仓结果": 2258,
    "寻源过程": 2259,
    "寻源占单详情": 2260,
    "寻源详情": 2261,
    "寻源占单": 2262,
    "修改地址": 2263,
    "指定数量": 2264,
    "开始生产日期/天数": 2265,
    "结束生产日期/天数": 2266,
    "【指定数量】只能为正整数！": 2267,
    "复制收货信息": 2268,
    "修改": 2269,
    "物流轨迹": 2270,
    "收件人信息": 2271,
    "功能按钮": 2272,
    "支持上下拖拽排序": 2273,
    "最多显示50个筛选条件": 2274,
    "订单明细导入": 2275,
    "运费": 2276,
    "智能匹配地址": 2277,
    "如:张三,17788888888,上海上海市闵行区黎安路999号（输入后请按Enter键）": 2278,
    "电话": 2279,
    "在线支付": 2280,
    "存在超长录入！": 2281,
    "卖家备注超长！": 2282,
    "收货人超长！": 2283,
    "收货人电话超长！": 2284,
    "收货人邮编超长！": 2285,
    "订单明细不能为空！": 2286,
    "组合": 2287,
    "批量拆单-按行拆单": 2288,
    "批量拆单-一单一货": 2289,
    "查库存": 2290,
    "非批量时，仅展示对应平台下的店铺": 2291,
    "上下架状态": 2292,
    "上架": 2293,
    "下架": 2294,
    "零售价必填": 2295,
    "商城商品名称": 2296,
    "原商城商品名称": 2297,
    "新商城商品名称": 2298,
    "原平台类目": 2299,
    "新平台类目": 2300,
    "请选择平台类目！": 2301,
    "请输入商城商品名称！": 2302,
    "商品将被": 2303,
    "是否确认？": 2304,
    "请先选择需要通知发货的记录": 2305,
    "修改零售价": 2306,
    "下架原因": 2307,
    "请填写下架原因": 2308,
    "星期一": 2309,
    "请先填写正确的周指标或者周指标调整": 2310,
    "周指标之和不等于计划销售指标": 2311,
    "周指标调整之和不等于计划销售指标": 2312,
    "日指标之和不等于计划销售指标": 2313,
    "合单平台单号": 2314,
    "请选择平台单号": 2315,
    "当前礼品卡信息，是否确认？": 2316,
    "请选择平台单号！": 2317,
    "HOLD单": 2318,
    "订单卡单": 2319,
    "退货与退款": 2320,
    "重新寻源": 2321,
    "请选择退货明细！": 2322,
    "退货明细": 2323,
    "换货明细": 2324,
    "换货预留库存": 2325,
    "登录界面背景图": 2326,
    "登录界面LOGO": 2327,
    "门店档案": 2328,
    "门店": 2329,
    "背景图设置表": 2330,
    "请选择门店": 2331,
    "请填写备注": 2332,
    "请选择登录界面背景图": 2333,
    "上传图片": 2334,
    "最多添加10张图片": 2335,
    "支持图片格式": 2336,
    "上传文件只能是jpg、png、gif、jpeg格式!": 2337,
    "图片凭证": 2338,
    "商品应退总金额": 2339,
    "应退邮费": 2340,
    "换货|补发总金额": 2341,
    "退款总金额": 2342,
    "平台退款总金额": 2343,
    "勾选【退货明细】后将自动添加至【换货明细】": 2344,
    "扫描出库": 2345,
    "扫描作业": 2346,
    "商品扫描": 2347,
    "扫描": 2348,
    "反冲": 2349,
    "部分出库": 2350,
    "作业实时动态": 2351,
    "总数": 2352,
    "未扫描数": 2353,
    "已扫描数": 2354,
    "已装箱数": 2355,
    "新增箱": 2356,
    "拣货明细": 2357,
    "来源出库通知单": 2358,
    "装箱明细": 2359,
    "来源出库结果单": 2360,
    "日志信息": 2361,
    "未扫描商品": 2362,
    "确认执行删除箱?": 2363,
    "确认清空?": 2364,
    "返回将不会保留你修改的内容,确定返回吗?": 2365,
    "错误提示": 2366,
    "您的浏览器不支持 audio 与元素。": 2367,
    "来源入库通知单": 2368,
    "来源入库结果单": 2369,
    "优先展示根据平台单号匹配的待入库的退单，当匹配不到退单时展示匹配的可退的订单": 2370,
    "当单据数据来源为退单时，物流单号不一致不允许合并入库": 2371,
    "单据数据来源": 2372,
    "选择入库单据": 2373,
    "请选择入库单据": 2374,
    "退单明细": 2375,
    "退货备注": 2376,
    "订单和退单均匹配不到时可通过选择订单退": 2377,
    "入库单信息": 2378,
    "扫描明细": 2379,
    "扫描区域": 2380,
    "自动匹配扫描数量": 2381,
    "客户姓名": 2382,
    "扫描人员": 2383,
    "机损": 2384,
    "箱损": 2385,
    "在途库存": 2386,
    "按选择明细退": 2387,
    "全部明细退": 2388,
    "未找到单据，可扫描商品SKU后进行无名件入库或者通过选择订单进行入库": 2389,
    "入库成功": 2390,
    "请选择需要入库的订单明细": 2391,
    "请输入查询内容": 2392,
    "通知仓库": 2393,
    "是否确认切换通知仓库，该操作将丢失未保存的数据！": 2394,
    "通知类型": 2395,
    "由业务参数默认带出": 2396,
    "是否确认切换通知类型，该操作将丢失未保存的数据！": 2397,
    "商品代码": 2398,
    "已通知数": 2399,
    "未通知数": 2400,
    "已配未发数": 2401,
    "已配已发数": 2402,
    "未配货数": 2403,
    "本次通知数": 2404,
    "不可大于本次未通知数！": 2405,
    "不可大于本次未配货数！": 2406,
    "已入库数": 2407,
    "未入库数": 2408,
    "请选择要通知入库的指定商品！": 2409,
    "是否确认通知入库？": 2410,
    "不可大于本次未入库数！": 2411,
    "选择模板": 2412,
    "文件生成成功！": 2413,
    "去预览/打印/下载": 2414,
    "请选择打印模板！": 2415,
    "选择物流公司": 2416,
    "获取单号数量": 2417,
    "请维护物流公司!": 2418,
    "包材类型": 2419,
    "已选中包材": 2420,
    "提货码": 2421,
    "选择包材": 2422,
    "选择冻结库存条码": 2423,
    "请维护拒单原因": 2424,
    "请维护选择冻结库存条码": 2425,
    "总件数": 2426,
    "待复核数": 2427,
    "已复核数": 2428,
    "购买明细": 2429,
    "未复核": 2430,
    "复核完毕": 2431,
    "购买数": 2432,
    "商品扫描区": 2433,
    "包裹列表": 2434,
    "请扫描国标码": 2435,
    "请输入国标码": 2436,
    "确定并打印装箱单": 2437,
    "添加到包裹列表": 2438,
    "商品货号": 2439,
    "该商品已复核完成！": 2440,
    "请输入包材": 2441,
    "请扫描商品条码": 2442,
    "请扫描商品并添加包裹": 2443,
    "请全部复核后，确认并打印装箱单": 2444,
    "请全部复核后再确认": 2445,
    "请选择物流公司": 2446,
    "包裹数与申请的物流单号数不一致，请确认！": 2447,
    "只有订单是待审核或缺货的才能操作": 2448,
    "取消商品": 2449,
    "行颜色填充为": 2450,
    "缺货商品": 2451,
    "成交总额": 2452,
    "用卡订单使用的本金": 2453,
    "用卡订单使用的权益金": 2454,
    "备注信息": 2455,
    "下载图片": 2456,
    "请输入折扣": 2457,
    "请输入价格": 2458,
    "收货店仓︰": 2459,
    "矩阵录入": 2460,
    "彩色区为发货店仓库存情况": 2461,
    "退换货订单明细": 2462,
    "查询原始订单编号": 2463,
    "无赠品可添加！": 2464,
    "发货实体仓": 2465,
    "承运商": 2466,
    "自动释放": 2467,
    "释放时点": 2468,
    "指定时点释放": 2469,
    "固定时长后释放": 2470,
    "分钟": 2471,
    "小时": 2472,
    "天": 2473,
    "指定时点释放的时间不能为空": 2474,
    "指定时点释放的时间不能小于当前时间": 2475,
    "固定时长后释放的固定时长只能是整数": 2476,
    "固定时长后释放的相关数据不能为空": 2477,
    "释放时点不能为空": 2478,
    "商品SKU名称": 2479,
    "sku查询失败": 2480,
    "替换前商品sku不能为空": 2481,
    "替换后商品sku码不能为空": 2482,
    "替换商品与被替换商品不能相同": 2483,
    "请勾选订单数据": 2484,
    "日程归属名称": 2485,
    "档案日程归属不能为空！": 2486,
    "出仓单": 2487,
    "请先选择一条数据更换吊牌！": 2488,
    "非【缺货】状态，不能进行换吊牌操作！": 2489,
    "JIT配货单换吊牌": 2490,
    "至少选择一条订单明细": 2491,
    "请选中其中一条记录": 2492,
    "请选中一条记录": 2493,
    "库存": 2494,
    "结算总额": 2495,
    "优惠金额": 2496,
    "平摊金额": 2497,
    "退款状态": 2498,
    "HOLD单原因": 2499,
    "直播HOLD单": 2500,
    "HOLD单原因不能为空": 2501,
    "档期日程归属": 2502,
    "日程归属": 2503,
    "识别号": 2504,
    "公司地址": 2505,
    "开户行账号": 2506,
    "收票地址": 2507,
    "发票抬头不能为空": 2508,
    "专用发票": 2509,
    "识别号不能为空": 2510,
    "公司地址不能为空": 2511,
    "电话号码不能为空": 2512,
    "开户银行不能为空": 2513,
    "开户行账号不能为空": 2514,
    "保存未成功": 2515,
    "押金订单号": 2516,
    "查询": 2517,
    "卖家昵称": 2518,
    "会员加急发货打标成功": 2519,
    "请选择物流单号": 2520,
    "快递名称": 2521,
    "快递编码": 2522,
    "简称": 2523,
    "请输入物流单号！": 2524,
    "请输入传WMS拣货单字段！": 2525,
    "查询数据为空": 2526,
    "请选中订单数据": 2527,
    "请选中需要新增的赠品": 2528,
    "sku不能为空！": 2529,
    "请填写收货人手机": 2530,
    "请填写收货人名称": 2531,
    "请填写省份！": 2532,
    "请填写城市！": 2533,
    "请填写详细地址！": 2534,
    "收货人手机不合法": 2535,
    "收货人电话不合法": 2536,
    "邮编不合法": 2537,
    "请正确填写省份": 2538,
    "请正确填写城市": 2539,
    "请正确填写区县": 2540,
    "省份查询失败": 2541,
    "请先选择省份": 2542,
    "城市查询失败": 2543,
    "请先选择城市": 2544,
    "区县查询失败": 2545,
    "下载类型": 2546,
    "仅下载拣货单": 2547,
    "创建并下载拣货单": 2548,
    "拣货单类型": 2549,
    "普通": 2550,
    "补货单": 2551,
    "预调拨": 2552,
    "手工占单成功！": 2553,
    "合并占单成功！": 2554,
    "入库实体仓库必填！": 2555,
    "拒绝打款原因不能为空！": 2556,
    "配送物流": 2557,
    "是否开票": 2558,
    "内部备注": 2559,
    "请填入完整信息,如:张三,17788888888,上海上海市闵行区黎安路999号": 2560,
    "收货人区": 2561,
    "发货店仓，不能为空": 2562,
    "订单存在非赠品的成交金额为0， 是否确定保存订单？": 2563,
    "订单管理编辑": 2564,
    "明细保存失败！": 2565,
    "请输入条码！": 2566,
    "不存在该条码！": 2567,
    "省市区": 2568,
    "订单状态已审核，建议反审核再修改地址": 2569,
    "订单状态非未确认、缺货、已审核、配货中，不允许修改地址": 2570,
    "平台订单号": 2571,
    "收件人": 2572,
    "入库数量": 2573,
    "单件退货金额": 2574,
    "换货金额": 2575,
    "总计": 2576,
    "请选择需要历史单平台发货的记录！": 2577,
    "请选择需要取消加急的记录！": 2578,
    "是否确定取消加急？": 2579,
    "请选择需要额外退款的记录": 2580,
    "只能选择一条记录进行退款": 2581,
    "只有仓库发货或者平台发货的订单才能操作额外退款": 2582,
    "手工创建": 2583,
    "请确认订单是否冻结库存并重新寻源？": 2584,
    "请选择需要重新寻源的记录!": 2585,
    "开票通知": 2586,
    "请选择需要开票的订单": 2587,
    "请选择一条订单": 2588,
    "订单取消": 2589,
    "拆分订单": 2590,
    "拦截、退款中的订单不允许拆单！": 2591,
    "只允许拆分待审核和缺货状态的订单！": 2592,
    "新增退单": 2593,
    "缺货重新占单": 2594,
    "福袋缺货重新占单": 2595,
    "备注导入": 2596,
    "更改为平台发货": 2597,
    "批量改商品": 2598,
    "批量拆单": 2599,
    "选择的订单中存在非待审核订单, 不允许释放库存！": 2600,
    "请选择需要库存释放的订单！": 2601,
    "是否原退": 2602,
    "订单详情获取失败": 2603,
    "仓库发货": 2604,
    "平台发货": 2605,
    "请选择需要审核的记录！": 2606,
    "要合并的单据的付款方式只能为非货到付款": 2607,
    "要合并的单据的预售状态只能为非预售": 2608,
    "要合并的单据的发货仓库只能为非空": 2609,
    "合并订单成功": 2610,
    "合并订单失败": 2611,
    "当前状态异常，不允许操作！": 2612,
    "取消合并订单成功": 2613,
    "取消合并订单失败": 2614,
    "请选择需要卡单释放的数据": 2615,
    "请选择需要更换的商品！": 2616,
    "不可以选择更换当前商品！": 2617,
    "请填写筛选条件！": 2618,
    "添加到待拆单": 2619,
    "确认拆单": 2620,
    "当前操作未确认拆单，是否确认刷新？": 2621,
    "已是原始状态，不执行操作！": 2622,
    "可售数量": 2623,
    "待拆数量": 2624,
    "拆分数量": 2625,
    "拆分数量不能大于待拆数量；不进行拆单！": 2626,
    "发货仓库名称": 2627,
    "发货仓库编码": 2628,
    "请选择需要拆分的明细！": 2629,
    "拆分数量不能为0！": 2630,
    "没有可拆分的订单！": 2631,
    "请先选择拆单明细添加到待拆单，再进行拆单！": 2632,
    "订单总额": 2633,
    "退款分类": 2634,
    "退款描述": 2635,
    "收款人姓名": 2636,
    "额外退款": 2637,
    "退货数量": 2638,
    "实际退款金额": 2639,
    "查询不到数据！": 2640,
    "请输入正确的买家手机号": 2641,
    "原始订单编号不能为空！": 2642,
    "没有明细可新增": 2643,
    "至少保留一条明细,不允许全部删除！": 2644,
    "确定删除所选明细?": 2645,
    "退款描述请求失败": 2646,
    "亲，您好！您的订单号": 2647,
    "因为": 2648,
    "原因，给您申请": 2649,
    "元的额外退款，我们将会在 3 个工作日之内给您打到您": 2650,
    "中，请您注意查收！感谢您的惠顾，欢迎下次光临，祝您生活愉快！": 2651,
    "售后审核": 2652,
    "手动入库": 2653,
    "取消自动退款": 2654,
    "修改退回仓库": 2655,
    "修改物流公司": 2656,
    "批量原退": 2657,
    "强制完成": 2658,
    "退换货复制": 2659,
    "卖家备注导入": 2660,
    "异常信息": 2661,
    "修改退货仓库": 2662,
    "此退换单状态不允许扫描入库,请重新选择！": 2663,
    "当前选中行，无法使用此按钮！": 2664,
    "单据状态不符合审核条件，请重新选择": 2665,
    "售后审核失败！": 2666,
    "退换货取消失败,只有【等待退货入库】状态才可以操作取消，请检查后重试！": 2667,
    "换货订单的状态为配货中或已经发货,是否确认直接取消退货？": 2668,
    "取消失败！": 2669,
    "是否确定虚拟入库？": 2670,
    "取消自动退款失败！": 2671,
    "请至少选中一项修改": 2672,
    "批量原退失败！": 2673,
    "是否确定批量换货转退货": 2674,
    "只有等待退货入库状态可以从WMS撤回": 2675,
    "从wms撤回失败！": 2676,
    "重WMS失败！": 2677,
    "请选中一条单据进行复制！": 2678,
    "不允许批量处理！": 2679,
    "标记次品已调拨": 2680,
    "退换货订单": 2681,
    "换货平台单号": 2682,
    "退货": 2683,
    "退换货": 2684,
    "发货实体仓库": 2685,
    "是否生成换货单": 2686,
    "传DRP次数": 2687,
    "传DRP失败原因": 2688,
    "退货状态": 2689,
    "请先填入原订单信息": 2690,
    "省市区id获取失败": 2691,
    "换货邮费": 2692,
    "退货单日志": 2693,
    "次品记录": 2694,
    "次品调拨状态": 2695,
    "获取详情失败！": 2696,
    "传WMS成功状态的单据不可修改！": 2697,
    "只有等待退货入库和等待售后确认状态的单据 或 完成状态且虚拟入库未入库状态的单据可修改！": 2698,
    "省市信息必填！": 2699,
    "收货人姓名不合法，请重新填写！": 2700,
    "收货人必填！": 2701,
    "收货人手机必填！": 2702,
    "电话号码不合法，请重新填写！": 2703,
    "收货人地址必填！": 2704,
    "退货明细必须有行数据！": 2705,
    "换货明细必须有行数据！": 2706,
    "换货金额必须等于退货金额！": 2707,
    "退货总金额不能小于0，请修改后重新保存！": 2708,
    "请输入正确的换货邮费！": 2709,
    "退货明细数量不能为0！": 2710,
    "退货明细条码不能为空！": 2711,
    "换货明细换货数量不能为空": 2712,
    "换货明细条码不能为空": 2713,
    "可用库存查询失败": 2714,
    "新增退换货订单失败！": 2715,
    "强制完成失败！": 2716,
    "请选择一条需要删除的明细！": 2717,
    "不允许批量删除明细！": 2718,
    "原始平台单号存在多条记录，请用订单编号查询！": 2719,
    "未查询到数据！": 2720,
    "只能选择一条订单记录！": 2721,
    "收货方名称": 2722,
    "必须填写物流单号才能强制保存": 2723,
    "扫描数量不能为零！": 2724,
    "退货批次不能为空！": 2725,
    "强制入库失败": 2726,
    "销退入库仓": 2727,
    "手机号码": 2728,
    "退货入库单中存在此物流单号，不允许扫描入库！": 2729,
    "数据": 2730,
    "强制入库": 2731,
    "清除": 2732,
    "退换货备注": 2733,
    "收件人手机": 2734,
    "批次类型": 2735,
    "原发货仓": 2736,
    "实收国标码": 2737,
    "销退入库仓不能为空！": 2738,
    "是否自动匹配": 2739,
    "鞋盒条码与实物条码不符": 2740,
    "实收条码不能为空": 2741,
    "实收条码与发出条码一致，请检查后重新扫描": 2742,
    "本地条码档案中不存在此条码，请检查后重试": 2743,
    "请先选择一行记录进行扫描": 2744,
    "原平台单号": 2745,
    "联系电话": 2746,
    "发货地址": 2747,
    "请输入退单编号": 2748,
    "请输入手机号码": 2749,
    "买家昵称超长！": 2750,
    "退货人姓名超长！": 2751,
    "退货原因超长！": 2752,
    "退回运单号超长！": 2753,
    "单据备注超长！": 2754,
    "请选择一条需要替换的明细！": 2755,
    "请选择一条订单明细！": 2756,
    "只能一条订单明细！": 2757,
    "平台编号": 2758,
    "平台交易状态": 2759,
    "是否自提": 2760,
    "发货门店名称": 2761,
    "发货门店编码": 2762,
    "订单状态不满足，不允许修改地址！": 2763,
    "杭州店仓": 2764,
    "待分配": 2765,
    "配货中": 2766,
    "平台发货失败": 2767,
    "取消/作废": 2768,
    "待换货": 2769,
    "待确认-换货完成": 2770,
    "已签收": 2771,
    "手工匹配": 2772,
    "请选择一条明细手工匹配": 2773,
    "只能选择一条明细手工匹配": 2774,
    "状态不匹配不能进入手动匹配": 2775,
    "错发强制匹配": 2776,
    "请选择一条明细错发强制匹配": 2777,
    "只能选择一条明细错发强制匹配": 2778,
    "状态不匹配不能进入错发强制匹配": 2779,
    "作废操作成功": 2780,
    "作废操作失败": 2781,
    "是否关闭匹配": 2782,
    "是否生成入库单": 2783,
    "是否生成错发调整单": 2784,
    "是否生成冲无头件调整单": 2785,
    "退货入库明细不能为空！": 2786,
    "请勾选需要操作的单据！": 2787,
    "换货人信息": 2788,
    "添加标记": 2789,
    "买家HOLD单": 2790,
    "是否确定修改内部备注？": 2791,
    "被替换商品SKU": 2792,
    "替换后商品SKU": 2793,
    "将": 2794,
    "替换为": 2795,
    "旗帜": 2796,
    "当前备注:": 2797,
    "修改备注:": 2798,
    "是否确认修改备注！": 2799,
    "改仓原因": 2800,
    "原仓缺货改仓": 2801,
    "系统错判改仓": 2802,
    "新增仓库改仓": 2803,
    "运输方式": 2804,
    "唯品会入库单": 2805,
    "开票状态": 2806,
    "开专用发票必须跟开票专员确认": 2807,
    "当前操作会给订单打上加急发货【急】标识，请确认！": 2808,
    "收货信息": 2809,
    "新收货信息": 2810,
    "新地址": 2811,
    "平台地址": 2812,
    "新详细地址": 2813,
    "系统备注": 2814,
    "按页面已勾选订单": 2815,
    "按筛选条件选中订单": 2816,
    "强制匹配": 2817,
    "查询退单": 2818,
    "清除退单": 2819,
    "未做任何修改！": 2820,
    "失败信息！": 2821,
    "失败明细！": 2822,
    "已匹配退货单号，不允许清除！": 2823,
    "未匹配退换货单，不允许清除！": 2824,
    "存在明细已经匹配退货单，请重新进行选择！": 2825,
    "条码一致，请走手工匹配！": 2826,
    "没有匹配到退货单明细！": 2827,
    "失败序号": 2828,
    "失败SKU": 2829,
    "失败原因！": 2830,
    "匹配失败提示框": 2831,
    "清除失败提示框": 2832,
    "拒绝打款原因": 2833,
    "请输入拒绝打款原因": 2834,
    "单据备注": 2835,
    "原订单编号不能为空！": 2836,
    "订单收货地址": 2837,
    "切换为sku商品显示": 2838,
    "切换为平台商品明细": 2839,
    "商品优惠": 2840,
    "订单优惠": 2841,
    "将对查询出的订单数据重新分配快递，是否继续?": 2842,
    "将对查询出的订单数据重新分配仓库，是否继续?": 2843,
    "批量生成退换货订单，是否继续?": 2844,
    "是否确定反审核订单？": 2845,
    "取消拦截": 2846,
    "新增工单": 2847,
    "只允许仓库发货、平台发货状态订单允许新增退单！": 2848,
    "是否确定重新寻源？": 2849,
    "添加商品-已选": 2850,
    "替换明细": 2851,
    "删除退货商品！": 2852,
    "请确认是否删除当前选中的退货商品，还存在关联的挂靠赠品": 2853,
    "请确认是否删除当前选中的退货商品，还存在组合/福袋下挂的其他关联商品": 2854,
    "并且还存在组合/福袋下挂的其他关联商品": 2855,
    "请确认是否删除当前选中的退货商品？": 2856,
    "删除换货商品": 2857,
    "请确认是否删除当前选中的换货商品？": 2858,
    "请选择一条明细！": 2859,
    "商品应退金额": 2860,
    "应退运费": 2861,
    "最终应退总金额": 2862,
    "查询原平台单号": 2863,
    "输入后请按Enter": 2864,
    "没有查询到当前平台单号！": 2865,
    "退货明细不能为空！": 2866,
    "换货明细不能为空！": 2867,
    "最终应退总金额不能小于0！": 2868,
    "换货金额与退货金额不一致请重新确认！": 2869,
    "退换货单详情": 2870,
    "换货人信息请切换为明文！": 2871,
    "退换货单明细都不能为空！": 2872,
    "换货金额必须要和退货金额一致！": 2873,
    "退货单不能为空！": 2874,
    "退款又发货": 2875,
    "退款未入库": 2876,
    "退款后换货发货": 2877,
    "急速退款发货预警": 2878,
    "点击后将删除凭证,是否继续?": 2879,
    "退款类型": 2880,
    "仅退款": 2881,
    "退货退款": 2882,
    "退款单详情": 2883,
    "原始退单明细": 2884,
    "商品实退金额": 2885,
    "最终实退总金额": 2886,
    "新增退货明细": 2887,
    "扫描信息": 2888,
    "录入信息": 2889,
    "退换货信息": 2890,
    "条码不在列表中,是否继续添加?": 2891,
    "未能匹配相应的退换货单，是否继续?": 2892,
    "商品金额": 2893,
    "订单优惠金额": 2894,
    "商品优惠金额": 2895,
    "商品总金额": 2896,
    "零售价合计": 2897,
    "请勾选一条赠品！": 2898,
    "只能勾选一条赠品！": 2899,
    "数量不能为空，请输入！": 2900,
    "换吊牌的实际条码总拣货数为": 2901,
    "不等于原始条码的拣货数": 2902,
    "请勾选至少两笔订单进行": 2903,
    "Hold单时间": 2904,
    "Hold单原因": 2905,
    "异常原因": 2906,
    "复制类型": 2907,
    "补发类型": 2908,
    "预售付定金时间": 2909,
    "阶段付款状态": 2910,
    "合并的平台单号": 2911,
    "是否将所选订单批量增加": 2912,
    "原单必须为取消/作废状态才可进行": 2913,
    "原单必须为非取消/作废状态才可进行": 2914,
    "已选中的第": 2915,
    "行没有可拆分的订单": 2916,
    "只有等待退货入库状态可以从WMS撤回!": 2917,
    "出库拣货单": 2918,
    "号箱": 2919,
    "未扫描商品不存在": 2920,
    "条码或国标码": 2921,
    "扫描数量已超出": 2922,
    "数量不能大于1": 2923,
    "已扫描": 2924,
    "当前拣货箱不存在条码": 2925,
    "不允许为负值": 2926,
    "当前拣货箱不存在箱号": 2927,
    "入库拣货单": 2928,
    "是否确定": 2929,
    "组合-成分品": 2930,
    "订单类型": 2931,
    "平台标记": 2932,
    "收货人门牌号": 2933,
    "收货人公司": 2934,
    "详情": 2935,
    "请选择需要操作的明细！": 2936,
    "错发强制匹配一次只能选中一条明细！": 2937,
    "请选择一条数据": 2938,
    "请选择数据后再操作！": 2939,
    "无名件入库结果单详情": 2940,
    "退货金额不能大于": 2941,
    "已存在，请重新输入": 2942,
    "是否确认给所选订单打上": 2943,
    "是否确认将所选订单取消": 2944,
    "至少保留一条明细！": 2945,
    "顾客退款": 2946,
    "退款时间": 2947,
    "【指定数量】不能大于【销售数量】": 2948,
    "当前订单状态不允许修改预计发货时间！": 2949,
    "请选择要通知发货的指定商品！": 2950,
    "是否确认通知发货？": 2951,
    "请选择一条单据进行【{}】操作！": 2952,
    "不支持批量【{}】操作，请选择一条单据！": 2953,
    "请选择至少一条单据进行【{}】操作！": 2954,
    "已选中{}条订单，是否确认执行【{}】操作?": 2955,
    "退货单号为{}的，{}": 2956,
    "当前第{}行数据的 开始生产日期为【{}】，填写错误，请重新填写！": 2957,
    "当前第{}行数据的 结束生产日期为【{}】，填写错误，请重新填写！": 2958,
    "当前第{}行数据的第{}条明细 生产日期为【{}】，填写错误，请重新填写！": 2959,
    "当前单据为{}，是否进行换单！": 2960,
    "上传图片只能是{}格式！": 2961,
    "上传图片大小不能超过{}MB！": 2962,
    "退货单号": 2963,
    "是否继续？": 2964,
    "客服卡单-疫情停发": 2965,
    "客服卡单-延期等通知": 2966,
    "审单卡单-疫情停发": 2967,
    "客服卡单-运营要求": 2968,
    "销管卡单-运营要求": 2969,
    "审单卡单-运营要求": 2970,
    "虚拟入库未入库": 2971,
    "SN编码": 2972,
    "批次": 2973,
    "批次明细": 2974,
    "EXCEL导入": 2975,
    "原始订单ID": 2976,
    "原始订单明细ID": 2977,
    "订单明细ID": 2978,
    "条码名称": 2979,
    "商品单价": 2980,
    "平台退款金额": 2981,
    "订单承担优惠": 2982,
    "商家承担优惠": 2983,
    "差价金额": 2984,
    "商品退款金额": 2985,
    "现金券": 2986,
    "扣款金额": 2987,
    "提前还款": 2988,
    "确认丢件": 2989,
    "是否货物找回": 2990,
    "现金优惠券": 2991,
    "折扣金额": 2992,
    "实际商品退款金额": 2993,
    "定制内容": 2994,
    "换货单价": 2995,
    "物流状态": 2996,
    "签收时间": 2997,
    "签收日期选择": 2998,
    "实际入库商品": 2999,
    "全部通知": 3000,
    "指定商品通知": 3001,
    "打印人": 3002,
    "打印时间": 3003,
    "自动匹配": 3004,
    "错发扫描处理": 3005,
    "处理意见": 3006,
    "请填写处理意见！": 3007,
    "原SN/IMSI信息": 3008,
    "新SN/IMSI信息": 3009,
    "批量更新SN/IMEI码": 3010,
    "请选择数据执行【{}】操作！": 3011,
    "只能选择一条数据执行【{}】操作！": 3012,
    "确认执行【{}】操作吗？": 3013,
    "工单确认": 3014,
    "工单已确认，不允许保存!": 3015,
    "请输入条码对应的物料代码！": 3016,
    "工单状态待确认，不允许确认!": 3017,
    "请选择处理方式!": 3018,
    "单据已作废!": 3019,
    "单据不为待确认，不允许作废!": 3020,
    "单据不为待确认，不允许删除!": 3021,
    "请选择需要删除的明细!": 3022,
    "LMA工单": 3023,
    "处理方式": 3024,
    "处理描述": 3025,
    "处理类型不为待客服处理,不允许同意退换货!": 3026,
    "理赔时间": 3027,
    "理赔款FSC单号": 3028,
    "理赔金额": 3029,
    "ERP订单生成日期": 3030,
    "ERP订单号": 3031,
    "请填写{}！": 3032,
    "取消标记": 3033,
    "退款失败": 3034,
    "请输入SN/IMEI信息": 3035,
    "是否确认更新IMEI信息，更新后会重新进行延保信息！": 3036,
    "查询来源单据": 3037,
    "不冻结": 3038,
    "拆单方式": 3039,
    "不拆单": 3040,
    "可拆单": 3041,
    "赠品后发": 3042,
    "发货时点": 3043,
    "主品平台发货后": 3044,
    "主品签收后发": 3045,
    "主品发货后多久发": 3046,
    "间隔时长(小时)": 3047,
    "发货时点或间隔时长不能为空！": 3048,
    "设置分组": 3049,
    "促销编号": 3050,
    "活动日期": 3051,
    "选择日期范围": 3052,
    "商品": 3053,
    "促销名称": 3054,
    "促销大类": 3055,
    "促销中类": 3056,
    "操作人": 3057,
    "促销状态": 3058,
    "保存草稿": 3059,
    "发布": 3060,
    "无商品数据，禁止操作": 3061,
    "起始时间": 3062,
    "反选": 3063,
    "平台SPU编码": 3064,
    "平台SKU编码": 3065,
    "平台SPU名称": 3066,
    "商品状态": 3067,
    "销售中": 3068,
    "仓库中": 3069,
    "是否系统组合商品": 3070,
    "促销执行明细": 3071,
    "中的": 3072,
    "件商品": 3073,
    "可选促销列表": 3074,
    "试算": 3075,
    "重选": 3076,
    "应收价": 3077,
    "参与收货仓": 3078,
    "只能选取一条数据!": 3079,
    "促销标签": 3080,
    "促销说明": 3081,
    "优惠方式": 3082,
    "是否享受VIP折上折": 3083,
    "优惠基础": 3084,
    "是否执行会员一口价": 3085,
    "是否参与积分抵扣": 3086,
    "是否参与会员一口价计价": 3087,
    "适用渠道": 3088,
    "允许最大翻倍": 3089,
    "请输入备注说明": 3090,
    "请输入活动名称": 3091,
    "请选择活动日期": 3092,
    "请选择活动频次": 3093,
    "请选择促销标签": 3094,
    "请选择促销说明": 3095,
    "请完善商品条件信息": 3096,
    "单据类型或时间类型不能为空": 3097,
    "排名不能为空": 3098,
    "请录入商品数据！": 3099,
    "并且": 3100,
    "条数超限": 3101,
    "特价": 3102,
    "保存行": 3103,
    "删除选中行": 3104,
    "请按模版填写": 3105,
    "请先选择要导入的文件！": 3106,
    "请选择要删除的信息": 3107,
    "排名在": 3108,
    "之间": 3109,
    "购买": 3110,
    "分组名称": 3111,
    "活动名称": 3112,
    "参与店铺": 3113,
    "原分组名称": 3114,
    "优先级": 3115,
    "请填写分组名称！": 3116,
    "有重复优先级！": 3117,
    "设置分组成功！": 3118,
    "校验完成": 3119,
    "获取促销详情异常": 3120,
    "编辑促销活动": 3121,
    "商品列表": 3122,
    "【满足条件】至少要选中一项并且填写数量或金额条件": 3123,
    "无数据": 3124,
    "赠品列表": 3125,
    "表格": 3126,
    "数量规则未填写": 3127,
    "基础信息": 3128,
    "条件信息": 3129,
    "活动概览": 3130,
    "最大翻倍数未填写！": 3131,
    "请先添加商品和赠品！": 3132,
    "商品列表无数据": 3133,
    "赠品列表无数据": 3134,
    "批量新增促销活动": 3135,
    "活动时间段": 3136,
    "失效下线时间": 3137,
    "剩余可送": 3138,
    "已送数量": 3139,
    "状态": 3140,
    "操作描述": 3141,
    "草稿": 3142,
    "已发布": 3143,
    "下线": 3144,
    "平台SKU名称": 3145,
    "间隔时长（小时）": 3146,
    "每次赠送数量": 3147,
    "赠送总计数量": 3148,
    "顺序号": 3149,
    "商品数据编号": 3150,
    "商品标题": 3151,
    "平台款号ID": 3152,
    "平台条码ID": 3153,
    "赠品商品编码": 3154,
    "赠送SPU名称": 3155,
    "排除省": 3156,
    "赠品信息": 3157,
    "活动名称未填写！": 3158,
    "店铺名称未填写！": 3159,
    "订单类型必选！": 3160,
    "时间范围未填写": 3161,
    "下线时间未填写！": 3162,
    "最大限制次数未填写！": 3163,
    "分组": 3164,
    "线下门店": 3165,
    "下线/过期": 3166,
    "参与商品": 3167,
    "批量新增": 3168,
    "复制": 3169,
    "模拟仿真": 3170,
    "查看日志": 3171,
    "请至少选择一个": 3172,
    "选择的促销活动已经下线/过期": 3173,
    "确定执行下线操作？": 3174,
    "新增促销活动": 3175,
    "选择的促销活动已经发布": 3176,
    "存在【下线过期】的促销，请重新选择": 3177,
    "仿真试算": 3178,
    "收货省份": 3179,
    "试算成功！": 3180,
    "店铺信息未填写": 3181,
    "时间类型未填写": 3182,
    "订单类型未填写": 3183,
    "收货省份未填写": 3184,
    "商品列表数据不能为空": 3185,
    "商品列表第": 3186,
    "行数据未填写完毕": 3187,
    "批量导入解析出现问题": 3188,
    "批量新增条件信息导入": 3189,
    "添加阶梯": 3190,
    "删除阶梯": 3191,
    "添加搭配": 3192,
    "删除搭配": 3193,
    "平台SKUID": 3194,
    "系统商品款号": 3195,
    "条件信息导入": 3196,
    "取消分组": 3197,
    "批量活动下线": 3198,
    "取消发布": 3199,
    "配销中心": 3200,
    "经销商": 3201,
    "下线过期": 3202,
    "已下线的促销活动不能取消发布": 3203,
    "请选择已发布状态的促销活动取消发布": 3204,
    "确定执行取消发布操作？": 3205,
    "请选择一个": 3206,
    "请选择已发布状态的促销活动刷新": 3207,
    "请选择一条数据进行复制操作": 3208,
    "选择活动类型": 3209,
    "设置促销活动": 3210,
    "试算并发布": 3211,
    "模拟订单设置": 3212,
    "购买排名": 3213,
    "试算执行结果": 3214,
    "下线时间": 3215,
    "活动类型": 3216,
    "梯度赠送": 3217,
    "订单备注": 3218,
    "备注内容": 3219,
    "（为空不做控制，关键字依次填写，用中文“；”隔开）": 3220,
    "单个买家参与活动次数": 3221,
    "最大次数": 3222,
    "条件信息设置": 3223,
    "商品来源": 3224,
    "赠品翻倍": 3225,
    "最大翻倍次数": 3226,
    "赠送方式": 3227,
    "赠品信息设置": 3228,
    "阶梯类型": 3229,
    "赠送总量": 3230,
    "添加活动SKU": 3231,
    "商品参与方式": 3232,
    "选择商品方式": 3233,
    "商品池设置": 3234,
    "执行促销": 3235,
    "吊牌金额": 3236,
    "零售金额": 3237,
    "活动频次": 3238,
    "预售天数": 3239,
    "活动范围": 3240,
    "参与时间范围": 3241,
    "活动方案": 3242,
    "是否与其他商品活动同时执行": 3243,
    "是否与全场活动同时执行": 3244,
    "换购条件": 3245,
    "条件商品来源": 3246,
    "优惠商品来源": 3247,
    "换购": 3248,
    "商品来源类型": 3249,
    "活动扣点": 3250,
    "是否与优惠券同享": 3251,
    "备注说明": 3252,
    "不限": 3253,
    "仅限同款": 3254,
    "仅限同吊牌价": 3255,
    "享受": 3256,
    "折": 3257,
    "大于等于": 3258,
    "大于": 3259,
    "等于": 3260,
    "重导": 3261,
    "商品不能为空": 3262,
    "特价不能为空": 3263,
    "最多导入10000条数据": 3264,
    "上传文件不是指定文件类型！": 3265,
    "上传文件大小不能超过 2MB": 3266,
    "商品特价导入模版": 3267,
    "请先选择要导入的文件": 3268,
    "暂无要导出的商品": 3269,
    "商品特价导出": 3270,
    "立享": 3271,
    "花呗分期": 3272,
    "免息": 3273,
    "3期": 3274,
    "6期": 3275,
    "12期": 3276,
    "类": 3277,
    "A类": 3278,
    "立享第1件": 3279,
    "以上": 3280,
    "第": 3281,
    "立减": 3282,
    "加": 3283,
    "优惠": 3284,
    "免": 3285,
    "排除商品": 3286,
    "购买商品": 3287,
    "购买 ": 3288,
    "类商品": 3289,
    "优惠商品": 3290,
    "赠送券": 3291,
    "张": 3292,
    "券": 3293,
    "赠送商品": 3294,
    "换购商品": 3295,
    "全场": 3296,
    "的商品，": 3297,
    "立享满": 3298,
    "满足": 3299,
    "标准商品档案": 3300,
    "线上促销详情": 3301,
    "组": 3302,
    "请勾选需要操作的数据！": 3303,
    "金额": 3304,
    "查询数量已超过": 3305,
    "上限，请修改查询条件": 3306,
    "第{}行数据未填写完毕": 3307,
    "商品列表第{}组第{}行数据未填写完毕": 3308,
    "赠品列表第{}组第{}行数据未填写完毕": 3309,
    "促销[{}]参与的商品有[{}],共优惠{}元": 3310,
    "该订单已满足【买赠】促销[{}],可赠送{}": 3311,
    "赠品信息导入": 3312,
    "按周": 3313,
    "按天": 3314,
    "周一": 3315,
    "周二": 3316,
    "周三": 3317,
    "周四": 3318,
    "周五": 3319,
    "周六": 3320,
    "周日": 3321,
    "每": 3322,
    "梯度送": 3323,
    "仅限VIP生日当日": 3324,
    "仅限VIP生日当周": 3325,
    "仅限VIP生日当月": 3326,
    "仅限活动日期": 3327,
    "自定义时间范围": 3328,
    "梯度换": 3329,
    "全部换": 3330,
    "商家最优": 3331,
    "顾客最优": 3332,
    "小程序": 3333,
    "最近一周": 3334,
    "最近一个月": 3335,
    "最近三个月": 3336,
    "仅限会员": 3337,
    "是否积分": 3338,
    "参与仓库": 3339,
    "会员等级": 3340,
    "线上店铺": 3341,
    "当前记录无明细，不允许审核": 3342,
    "商品导出": 3343,
    "当前的操作会执行全量导出，导出时间可能会比较慢！是否继续导出?": 3344,
    "导出成功！": 3345,
    "我的任务": 3346,
    "数据导出中": 3347,
    "库存日期": 3348,
    "店铺编码": 3349,
    "请选择库存日期！": 3350,
    "请选择查询时间": 3351,
    "日": 3352,
    "周": 3353,
    "月": 3354,
    "昨天": 3355,
    "7天": 3356,
    "30天": 3357,
    "库存总量": 3358,
    "款号": 3359,
    "款色": 3360,
    "销售额": 3361,
    "销售指标": 3362,
    "指标完成率": 3363,
    "销售件数": 3364,
    "小程序销售金额": 3365,
    "员工数": 3366,
    "人均产出": 3367,
    "本店": 3368,
    "今日": 3369,
    "工业绩": 3370,
    "营业员": 3371,
    "销售金额": 3372,
    "销售金额占比": 3373,
    "小票总单数": 3374,
    "连带率": 3375,
    "客单价": 3376,
    "Top次数": 3377,
    "畅销款TOP10": 3378,
    "销售收入": 3379,
    "收入占比": 3380,
    "数量占比": 3381,
    "平均折扣": 3382,
    "平均售价": 3383,
    "数据时间": 3384,
    "业绩": 3385,
    "批量删除": 3386,
    "批量增加": 3387,
    "选择店仓": 3388,
    "应用店铺": 3389,
    "请先选择店仓或店铺！": 3390,
    "付款时间为必填项,没有选择值!": 3391,
    "付款时间范围有误!": 3392,
    "订单金额（元）为必填项,没有输入值!": 3393,
    "订单金额范围设置有误!": 3394,
    "收货地址为必填项,没有输入值!": 3395,
    "提示信息": 3396,
    "物流公司明细": 3397,
    "可发物流公司": 3398,
    "不做要求": 3399,
    "排除物流公司": 3400,
    "请选择需要批量修改的单据记录！": 3401,
    "请添加物流公司！": 3402,
    "该物流公司已存在!": 3403,
    "开始时间（包含）": 3404,
    "结束时间（不包含）": 3405,
    "开始时间": 3406,
    "结束时间": 3407,
    "请选择开始时间或结束时间！": 3408,
    "开始时间必须小于结束时间！": 3409,
    "延期日期": 3410,
    "延期": 3411,
    "点击了取消!": 3412,
    "类型": 3413,
    "指定客户": 3414,
    "所有客户": 3415,
    "经营模式": 3416,
    "配销仓回退规则": 3417,
    "实体仓编码": 3418,
    "配销仓编码": 3419,
    "配销仓名称": 3420,
    "聚合仓编码": 3421,
    "聚合仓名称": 3422,
    "寻源规则": 3423,
    "前往设置仓库配送范围": 3424,
    "当前没有历史记录！": 3425,
    "请选择客户": 3426,
    "请先添加寻源仓库范围数据": 3427,
    "是否同意保存当前页面的数据？": 3428,
    "明细无数据，无法导出": 3429,
    "优先级不能相同": 3430,
    "请选择配销仓": 3431,
    "请先选择需要删除的数据!": 3432,
    "仅支持选择一项寻源规则！": 3433,
    "当前修改未保存，确定关闭？": 3434,
    "存在相互冲突的价格区间,请调整!": 3435,
    "只能选择一条数据！": 3436,
    "自动审核时间": 3437,
    "商品级别": 3438,
    "品类": 3439,
    "邮编类型": 3440,
    "邮编前几位": 3441,
    "配送区域类型": 3442,
    "国家明细": 3443,
    "请选择需要删除的明细！": 3444,
    "出现尚未保存的变更，是否仍要返回？": 3445,
    "前往设置评分策略": 3446,
    "计算公式：(店仓各评分因子值*权重)之和，决定各店仓的评分值": 3447,
    "指定仓库批次": 3448,
    "前往设置指定仓库批次": 3449,
    "指定仓库批次设置": 3450,
    "针对存在保质期商品，优先整单满足指定批次范围的仓库": 3451,
    "最小拆包数": 3452,
    "整单不满足情况下按照最小拆包数拆单": 3453,
    "暂无": 3454,
    "关闭寻源": 3455,
    "更新优先级": 3456,
    "启用寻源": 3457,
    "寻源": 3458,
    "供货": 3459,
    "设置优先级": 3460,
    "寻源&供货": 3461,
    "仅寻源": 3462,
    "仅供货": 3463,
    "启用寻源仓": 3464,
    "关闭寻源仓": 3465,
    "添加到已选列表": 3466,
    "共享比例": 3467,
    "保底库存": 3468,
    "已选条码": 3469,
    "已选方案": 3470,
    "不填则应用于所有已生效方案": 3471,
    "应用方案": 3472,
    "选择条码": 3473,
    "设置共享比例（%）": 3474,
    "设置保底库存数": 3475,
    "请先添加到已选列表！": 3476,
    "是否确认此操作？": 3477,
    "请设置共享比例！": 3478,
    "请设置保底库存数！": 3479,
    "请选择条码！": 3480,
    "已选仓库": 3481,
    "已选店铺": 3482,
    "已选中批量修改记录数": 3483,
    "行": 3484,
    "平台特殊": 3485,
    "未勾选记录,将批量更新所有查询结果": 3486,
    "共计": 3487,
    "行,是否确定继续操作": 3488,
    "默认发货逻辑仓": 3489,
    "占库存方法": 3490,
    "整单占": 3491,
    "部分占": 3492,
    "订单路由方案": 3493,
    "就近判断": 3494,
    "就全+就近判断": 3495,
    "缺货自动拆单": 3496,
    "默认退货实体仓": 3497,
    "启用GA(SA)": 3498,
    "寄售逻辑仓": 3499,
    "分仓模式": 3500,
    "按仓库库存就全": 3501,
    "按仓库优先级": 3502,
    "时效单释放时长": 3503,
    "未修改任何参数!": 3504,
    "自动审核货到付款": 3505,
    "排除实体仓": 3506,
    "排除业务单据类型": 3507,
    "包含关键字进行人工审核；多个关键字可依次填写，使用中文“，”隔开": 3508,
    "为空默认为有备注信息进行人工审核；多个关键字可依次填写，使用中文“，”隔开。": 3509,
    "生效结束时间": 3510,
    "策略": 3511,
    "寻源仓库范围": 3512,
    "回退配销仓范围": 3513,
    "点击添加行记录": 3514,
    "添加寻源规则行": 3515,
    "请输入支付时间": 3516,
    "等于关键字进行人工审核；多个关键字可依次填写，使用中文“，”隔开。": 3517,
    "类型值": 3518,
    "请输入值查询": 3519,
    "启用自动审核": 3520,
    "检查可合并订单": 3521,
    "全赠品订单开启自动审核": 3522,
    "修改时间后，延长一段时间再执行审核的时间": 3523,
    "用户执行反审核后，延长一段时间再执行重新审核的时间": 3524,
    "hold单等待时间": 3525,
    "手工订单": 3526,
    "订单折扣范围": 3527,
    "订单金额（元）": 3528,
    "收货地址": 3529,
    "买家留言": 3530,
    "自定义标签": 3531,
    "单条码数量上限": 3532,
    "限制商品信息": 3533,
    "固定时间": 3534,
    "商品标题/规格名称中可用特殊符号和文字": 3535,
    "渠道仓": 3536,
    "库存比例": 3537,
    "插入字段": 3538,
    "内容": 3539,
    "请选择省市区": 3540,
    "添加商品": 3541,
    "SPU编码/条码": 3542,
    "SPU名称/SKU名称": 3543,
    "JIT订单下发通知": 3544,
    "检索": 3545,
    "请确认是否需要删除仓库": 3546,
    "请确认是否需要删除物流公司": 3547,
    "策略参数选择": 3548,
    "寻源策略维护": 3549,
    "配销仓寻源策略": 3550,
    "设置寻源的配销仓范围": 3551,
    "配销仓寻源优先级设置": 3552,
    "前往配销仓寻源设置优先级策略": 3553,
    "流程图": 3554,
    "寻源规则 的优先级不能为空！": 3555,
    "寻源规则 的优先级不能相同！": 3556,
    "店优先，仓优先只能关闭其中一个规则，不能全部关闭！": 3557,
    "寻源定义编辑": 3558,
    "寻源策略定义（新）": 3559,
    "强制排除店仓规则": 3560,
    "寻源排除逻辑仓，被排除的逻辑仓不再参与订单寻源": 3561,
    "整单优先分配指定批次的仓库": 3562,
    "优先级高的实体仓优先发货": 3563,
    "寻源规则策略": 3564,
    "整单优先分配满足就近，仓辐射等寻源规则的仓库": 3565,
    "店仓评分策略": 3566,
    "店仓评分值高的实体仓优先发货": 3567,
    "整单优先": 3568,
    "开启后优先整单优先，整单不满足时再按照执行优先级顺序执行寻源类型。": 3569,
    "请选中一项寻源规则！": 3570,
    "规则已经存在！": 3571,
    "实体店仓": 3572,
    "物流公司": 3573,
    "延期日期不能为空！": 3574,
    "订单时间": 3575,
    "调整结束时间": 3576,
    "点击了取消！": 3577,
    "调整策略时间成功": 3578,
    "店仓档案": 3579,
    "策略名称": 3580,
    "启动自动审核": 3581,
    "{str} 不能为空": 3582,
    "金额区间不能小于{x}": 3583,
    "生效开始时间": 3584,
    "最低成交价格": 3585,
    "最低成交单价": 3586,
    "商品明细": 3587,
    "时间类型": 3588,
    "按系统创建时间等待": 3589,
    "支付时间": 3590,
    "单据标签": 3591,
    "释放时间": 3592,
    "指定时间点": 3593,
    "固定时长": 3594,
    "预售HOLD单": 3595,
    "据预计发货时间提前": 3596,
    "赠送积分": 3597,
    "订单标签": 3598,
    "店铺名称不能为空，请填写": 3599,
    "固定时长类型,固定时长及单位不能为空,请填写": 3600,
    "直播商品识别": 3601,
    "识别规则": 3602,
    "主播ID": 3603,
    "请录入主播ID": 3604,
    "主播昵称": 3605,
    "请录入主播昵称": 3606,
    "“播”标": 3607,
    "请勿重复添加直播商品识别规则!": 3608,
    "添加排除区域": 3609,
    "排除区域": 3610,
    "支持省份": 3611,
    "排除省份": 3612,
    "删除区域": 3613,
    "支持范围": 3614,
    "全国（含港澳台地区）": 3615,
    "自定义": 3616,
    "添加支持省份": 3617,
    "配送省份": 3618,
    "排除具体区域": 3619,
    "配送区域": 3620,
    "排除地区": 3621,
    "请选择要删除的明细": 3622,
    "分钟后自动审核": 3623,
    "只能选择一条数据": 3624,
    "请选择排除省份": 3625,
    "物流派送范围编辑": 3626,
    "修改内容": 3627,
    "修改前": 3628,
    "修改后": 3629,
    "已启用订单折扣限制，订单折扣范围不可为空": 3630,
    "起始折扣应小于或等于截止折扣": 3631,
    "付款时间为必填项,没有选择值": 3632,
    "付款时间范围有误": 3633,
    "已启用订单金额限制，订单金额不可为空": 3634,
    "起始金额应小于或等于截止金额": 3635,
    "收货地址为必填项,没有输入值": 3636,
    "请选择需要删除的数据": 3637,
    "日程规划名称": 3638,
    "规划开始时间": 3639,
    "规划结束时间": 3640,
    "大促": 3641,
    "日常": 3642,
    "补货独立入库": 3643,
    "自动补货数量限制": 3644,
    "拣货单创建时间": 3645,
    "唯品会仓库": 3646,
    "未拣货数维度": 3647,
    "PO维度": 3648,
    "单PO下唯品会仓库维度": 3649,
    "创建峰值": 3650,
    "自动拣货间隔时间": 3651,
    "创建条件": 3652,
    "当“店铺+唯品会仓库+发货仓库”相同的配货单中商品数量大于等于设置的峰值时，自动创建入库单": 3653,
    "创建内容": 3654,
    "空运": 3655,
    "汽运": 3656,
    "发货间隔": 3657,
    "当日": 3658,
    "次日": 3659,
    "到货间隔": 3660,
    "到货时间": 3661,
    "入库单结单": 3662,
    "每天在该时间点自动对创建的入库单结单": 3663,
    "确定删除？": 3664,
    "拣货单创建方式": 3665,
    "当前切换操作会清空已录入的按时间点创建/按未拣货数创建内容，确定继续吗？": 3666,
    "按时间点创建": 3667,
    "按未拣货数创建": 3668,
    "用户名": 3669,
    "日志类型": 3670,
    "修改人名称": 3671,
    "拣货单": 3672,
    "规则名称": 3673,
    "收货地址就近": 3674,
    "唯品会": 3675,
    "修改仓库": 3676,
    "仓库优先级": 3677,
    "发货比例": 3678,
    "发货数量": 3679,
    "按收货地址": 3680,
    "规则名称必填": 3681,
    "规则类型必填": 3682,
    "请先设置仓库": 3683,
    "订单派单规则编辑": 3684,
    "请先保存主表信息": 3685,
    "仓库必填": 3686,
    "仓库优先级必填必填": 3687,
    "新增成功": 3688,
    "新增失败": 3689,
    "派单规则明细": 3690,
    "分仓比例": 3691,
    "优先级设置重复！": 3692,
    "作废成功！": 3693,
    "作废失败！": 3694,
    "导出失败！": 3695,
    "删除失败！": 3696,
    "订单号": 3697,
    "入库单号": 3698,
    "到货仓": 3699,
    "商品总数量": 3700,
    "本单件数": 3701,
    "原单件数": 3702,
    "入库日期": 3703,
    "满足条件": 3704,
    "执行动作": 3705,
    "普通订单": 3706,
    "预售订单": 3707,
    "货到付款订单": 3708,
    "日期类型": 3709,
    "下单日期": 3710,
    "时间范围": 3711,
    "指定地址": 3712,
    "包含": 3713,
    "排除": 3714,
    "所在省": 3715,
    "所在市": 3716,
    "包裹属性": 3717,
    "开始值 大于等于": 3718,
    "结束值": 3719,
    "区间范围": 3720,
    "商品数量": 3721,
    "至": 3722,
    "件": 3723,
    "单据金额": 3724,
    "元": 3725,
    "包裹重量": 3726,
    "城市": 3727,
    "请选择要删除的仓库物流公司！": 3728,
    "启用状态，不可删除！": 3729,
    "请填写": 3730,
    "请选择单据类型": 3731,
    "请填写时间范围": 3732,
    "请填写您选中的开始值和结束值": 3733,
    "结束值需大于等于开始值": 3734,
    "特殊物流方案新增": 3735,
    "请选择要添加仓库物流": 3736,
    "请选择需要添加的数据": 3737,
    "启用状态，不可编辑": 3738,
    "省市搜索": 3739,
    "区域级别": 3740,
    "分仓策略-导入": 3741,
    "分仓规则编辑": 3742,
    "区域明细": 3743,
    "请输入唯品会仓库名称！": 3744,
    "换货地址": 3745,
    "请先选择店铺": 3746,
    "换货说明": 3747,
    "偏差N元同意换货<=": 3748,
    "有": 3749,
    "没有": 3750,
    "缺货自动拒绝": 3751,
    "缺货自动拒绝换货原因": 3752,
    "缺货自动拒绝文案": 3753,
    "偏差N元自动拒绝": 3754,
    "偏差N元拒绝换货>": 3755,
    "偏差N元自动拒绝换货原因": 3756,
    "偏差N元自动拒绝文案": 3757,
    "物流分配": 3758,
    "默认物流": 3759,
    "启用物流": 3760,
    "物流信息": 3761,
    "仓库编号": 3762,
    "物流编号": 3763,
    "生效日期": 3764,
    "结束日期": 3765,
    "方案名称": 3766,
    "方案描述": 3767,
    "结案人": 3768,
    "结案时间": 3769,
    "赔付类型": 3770,
    "价格赔付": 3771,
    "邮费赔付": 3772,
    "固定结算": 3773,
    "赔付标准": 3774,
    "邮费": 3775,
    "倍数": 3776,
    "结算价": 3777,
    "快递赔付方案": 3778,
    "实体仓不能为空": 3779,
    "生效日期不能为空": 3780,
    "结束日期不能为空": 3781,
    "方案名称不能为空": 3782,
    "明细为空不允许保存": 3783,
    "赔付标准和倍数不能为空": 3784,
    "结算价不能为空": 3785,
    "快递公司名称不能为空": 3786,
    "物流区域设置": 3787,
    "物流公司必填！": 3788,
    "数量过大，请使用导入功能设置是否到达！": 3789,
    "仓库物流优先级设置": 3790,
    "请选择物流区域！": 3791,
    "的物流优先级为空,保存会导致该数据删除,是否确认保存？": 3792,
    "修改物流": 3793,
    "基础资料": 3794,
    "零元订单自动审核": 3795,
    "等待审核时间": 3796,
    "反审核等待时间": 3797,
    "限制条件": 3798,
    "满足以下条件的订单需要人工审核": 3799,
    "是否正常订单": 3800,
    "是否预售订单": 3801,
    "是否换货订单": 3802,
    "订单金额": 3803,
    "条数据": 3804,
    "单据创建方式": 3805,
    "手工导入": 3806,
    "手工新增": 3807,
    "总金额": 3808,
    "满足以下条件的单据会进行hold单": 3809,
    "直播": 3810,
    "定预": 3811,
    "全预": 3812,
    "自预": 3813,
    "满足以下条件的单据打“播”标": 3814,
    "正常订单": 3815,
    "换货订单": 3816,
    "预售识别规则": 3817,
    "付款后": 3818,
    "自定义关键字": 3819,
    "清空明细": 3820,
    "系统SPU编码": 3821,
    "请输入识别内容，多关键字使用中文“，”隔开": 3822,
    "自动确认退货(仓库回传退货入库结果后，系统自动完成退货确认的业务操作)": 3823,
    "创建入库单": 3824,
    "渠道仓 - 库存比例": 3825,
    "安全库存数": 3826,
    "指定商品": 3827,
    "自动同意换货": 3828,
    "自动拒绝换货": 3829,
    "明细信息": 3830,
    "是否确认导出？": 3831,
    "经销": 3832,
    "代销": 3833,
    "联营": 3834,
    "配销仓优先级": 3835,
    "配销仓库存权重": 3836,
    "就近原则": 3837,
    "优先级不能为空，请维护": 3838,
    "存在相同的优先级，请修改": 3839,
    "TOB寻源定义编辑": 3840,
    "TOB寻源策略": 3841,
    "请选择实体仓或逻辑仓": 3842,
    "存在相同的【实体仓+逻辑仓】，请修改": 3843,
    "存在相同的【配销仓】，请修改": 3844,
    "不能为空": 3845,
    "买家留言为必填项,没有输入值!": 3846,
    "卖家备注为必填项,没有输入值!": 3847,
    "该组合已存在": 3848,
    "保存失败": 3849,
    "未发生变更，请变更后点击【确定】": 3850,
    "已存在，请重新设置": 3851,
    "删除条码": 3852,
    "仓优先 或 寻源规则 的优先级不能为空！": 3853,
    "明细中{}不能为空": 3854,
    "字段不能为空，请填写": 3855,
    "就全原则": 3856,
    "仓库配送范围设置": 3857,
    "同成本中心": 3858,
    "仓库评分": 3859,
    "门店评分": 3860,
    "门店等级": 3861,
    "店铺类型": 3862,
    "折扣店优先级高于正价店": 3863,
    "就近原则：区县->市区->省份->仓库配送范围；TOC仓辐射：按照商品、商品属性及省份设置仓库寻源优先级": 3864,
    "数字越大优先级越高！": 3865,
    "寻源类型": 3866,
    "店优先": 3867,
    "时": 3868,
    "“hold”标": 3869,
    "入库单创建时间": 3870,
    "最多只能添加5条!": 3871,
    "等待时间无效!": 3872,
    "时间类型及时间": 3873,
    "时间类型的时间不能为空，请填写！": 3874,
    "释放指定时间": 3875,
    "请选择原角色！": 3876,
    "请选择目的角色！": 3877,
    "目的角色不能包含原角色，请重新选择！": 3878,
    "角色": 3879,
    "刷新成功": 3880,
    "促销类型": 3881,
    "是否库存锁定": 3882,
    "库存同步比例": 3883,
    "平台店铺名称": 3884,
    "规格描述": 3885,
    "系统商品": 3886,
    "系统商品名称": 3887,
    "系统规格名称": 3888,
    "环境": 3889,
    "环境不能为空！": 3890,
    "图片格式": 3891,
    "图片大小": 3892,
    "建议图片尺寸": 3893,
    "保存并立即应用": 3894,
    "真实姓名": 3895,
    "联系方式": 3896,
    "异常操作": 3897,
    "异常操作原因": 3898,
    "不少于10个汉字": 3899,
    "您已明确该项操作的后果，愿意承担相应的责任，请慎重使用！": 3900,
    "请填写真实姓名！": 3901,
    "请填写正确的手机号！": 3902,
    "操作理由不能少于10个汉字！": 3903,
    "请阅读警告信息，若同意请勾选！": 3904,
    "异常处理": 3905,
    "填写单据ID,以逗号分隔，如：20201235001,20201235002": 3906,
    "按单据编号导入,以逗号分隔，如：RE20201235001,RE20201235002": 3907,
    "按店铺ID，逗号分隔；如：13345,13355,1678...": 3908,
    "日期": 3909,
    "按日期导入，逗号分隔；如：20200508，20200509，20200515...": 3910,
    "用户与商品": 3911,
    "请输入角色": 3912,
    "请输入商品": 3913,
    "共": 3914,
    "请选择复制方式": 3915,
    "店仓权限": 3916,
    "供应商权限": 3917,
    "配销中心权限": 3918,
    "品牌权限": 3919,
    "商品权限": 3920,
    "公司权限": 3921,
    "角色权限": 3922,
    "配销中心名称": 3923,
    "制单主店仓": 3924,
    "查看主店仓": 3925,
    "供应商编码": 3926,
    "供应商全称": 3927,
    "配销中心编码": 3928,
    "查看": 3929,
    "公司编码": 3930,
    "公司名称": 3931,
    "说明": 3932,
    "原角色": 3933,
    "目的角色": 3934,
    "复制方式": 3935,
    "覆盖原有权限": 3936,
    "保留原有权限": 3937,
    "原角色请求失败": 3938,
    "敏感列": 3939,
    "没有更改": 3940,
    "请输入机构编码或名称": 3941,
    "请输入 0 - 100 的库存同步比例值！": 3942,
    "小于": 3943,
    "上传头像图片最好是{}格式!": 3944,
    "上传头像图片大小最好不要超过{}MB!": 3945,
    "零售单重推ES": 3946,
    "零售单重调用库存": 3947,
    "店长导航数据归集": 3948,
    "按单号ID": 3949,
    "按照日期段": 3950,
    "按店铺ID": 3951,
    "按日期": 3952
}